export const global_marketlist = {
  "1": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Maç Sonucu",
    "group": "all|score|regular_play"
  },
  "2": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Finale çıkan",
    "group": "all|score|cup_tie"
  },
  "3": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Finali kazanacak takım",
    "group": "all|score|cup_tie"
  },
  "4": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Finalde 3. olacak takım",
    "group": "all|score|cup_tie"
  },
  "5": {
    "14": "{$competitor1} normal süre",
    "15": "{$competitor2} normal süre",
    "16": "{$competitor1} uzatmalar",
    "17": "{$competitor2} uzatmalar",
    "18": "{$competitor1} penaltılar",
    "19": "{$competitor2} penaltılar",
    "name": "Kazanma Yöntemi",
    "group": "all|score|cup_tie"
  },
  "6": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Maça başlayan takım",
    "group": "all|misc"
  },
  "7": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Sifir skor bahis",
    "group": "all|score|regular_play"
  },
  "8": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "{!goalnr} gol",
    "group": "all|score|regular_play"
  },
  "9": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "Son gol",
    "group": "all|score|regular_play"
  },
  "10": {
    "9": "{$competitor1}/X",
    "10": "{$competitor1} veya {$competitor2}",
    "11": "X veya {$competitor2}",
    "name": "Çifte Şans",
    "group": "all|score|regular_play"
  },
  "11": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Beraberlikte iade",
    "group": "all|score|regular_play"
  },
  "12": {
    "776": "X",
    "778": "{$competitor2}",
    "name": "{$competitor1} kazanırsa iade",
    "group": "all|score|regular_play"
  },
  "13": {
    "780": "{$competitor1}",
    "782": "X",
    "name": "{$competitor2} kazanırsa iade",
    "group": "all|score|regular_play"
  },
  "14": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "berabere ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "Handikap {hcp}",
    "group": "all|score|regular_play"
  },
  "16": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Handikap",
    "group": "all|score|regular_play"
  },
  "18": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Toplam gol",
    "group": "all|score|regular_play"
  },
  "19": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{$competitor1} toplam gol",
    "group": "all|score|regular_play"
  },
  "20": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{$competitor2} toplam gol",
    "group": "all|score|regular_play"
  },
  "26": {
    "70": "tek",
    "72": "çift",
    "name": "tek/çift",
    "group": "all|score|regular_play"
  },
  "27": {
    "70": "tek",
    "72": "çift",
    "name": "{$competitor1} tek/çift",
    "group": "all|score|regular_play"
  },
  "28": {
    "70": "tek",
    "72": "çift",
    "name": "{$competitor2} tek/çift",
    "group": "all|score|regular_play"
  },
  "29": {
    "74": "evet",
    "76": "hayır",
    "name": "Karşılıklı gol",
    "group": "all|score|regular_play"
  },
  "30": {
    "784": "Gol olmaz",
    "788": "sadece {$competitor1}",
    "790": "sadece {$competitor2}",
    "792": "her iki takım da",
    "name": "Golü atacak takım",
    "group": "all|score|regular_play"
  },
  "31": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor1} gol yemez",
    "group": "all|score|regular_play"
  },
  "32": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor2} gol yemez",
    "group": "all|score|regular_play"
  },
  "33": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor1} gol yemeden kazanır",
    "group": "all|score|regular_play"
  },
  "34": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor2} gol yemeden kazanır",
    "group": "all|score|regular_play"
  },
  "35": {
    "78": "{$competitor1} & var",
    "80": "{$competitor1} & yok",
    "82": "X & var",
    "84": "X & yok",
    "86": "{$competitor2} & var",
    "88": "{$competitor2} & yok",
    "name": "1x2 & her iki takım da gol bulur",
    "group": "all|regular_play|combo"
  },
  "36": {
    "90": "{total} +ü & var",
    "92": "{total} -ı & var",
    "94": "{total} +ü & yok",
    "96": "{total} -ı & yok",
    "name": "Toplam gol ve karşılıklı gol",
    "group": "all|regular_play|combo"
  },
  "37": {
    "794": "{$competitor1} & {total} -",
    "796": "{$competitor1} & {total} +",
    "798": "X & {total} -",
    "800": "X & {total} +",
    "802": "{$competitor2} & {total} -",
    "804": "{$competitor2} & {total} +",
    "name": "1x2 & toplam gol",
    "group": "all|regular_play|combo|incl_ot"
  },
  "38": {
    "1716": "gol olmaz",
    "name": "{!goalnr}. golü atan oyuncu",
    "group": "all|regular_play|scorers"
  },
  "39": {
    "1716": "gol olmaz",
    "name": "Son golü atan oyuncu",
    "group": "all|regular_play|scorers"
  },
  "40": {
    "1716": "gol olmaz",
    "name": "Gol atan oyuncu",
    "group": "all|regular_play|scorers"
  },
  "41": {
    "110": "0:0",
    "114": "1:0",
    "116": "2:0",
    "118": "3:0",
    "120": "4:0",
    "122": "5:0",
    "124": "6:0",
    "126": "0:1",
    "128": "1:1",
    "130": "2:1",
    "132": "3:1",
    "134": "4:1",
    "136": "5:1",
    "138": "0:2",
    "140": "1:2",
    "142": "2:2",
    "144": "3:2",
    "146": "4:2",
    "148": "0:3",
    "150": "1:3",
    "152": "2:3",
    "154": "3:3",
    "156": "0:4",
    "158": "1:4",
    "160": "2:4",
    "162": "0:5",
    "164": "1:5",
    "166": "0:6",
    "name": "Doğru skor {!score}",
    "group": "all|score|regular_play"
  },
  "45": {
    "274": "0:0",
    "276": "1:0",
    "278": "2:0",
    "280": "3:0",
    "282": "4:0",
    "284": "0:1",
    "286": "1:1",
    "288": "2:1",
    "290": "3:1",
    "292": "4:1",
    "294": "0:2",
    "296": "1:2",
    "298": "2:2",
    "300": "3:2",
    "302": "4:2",
    "304": "0:3",
    "306": "1:3",
    "308": "2:3",
    "310": "3:3",
    "312": "4:3",
    "314": "0:4",
    "316": "1:4",
    "318": "2:4",
    "320": "3:4",
    "322": "4:4",
    "324": "diğer",
    "name": "Doğru skor",
    "group": "all|score|regular_play"
  },
  "46": {
    "326": "0:0 0:0",
    "328": "0:0 0:1",
    "330": "0:0 0:2",
    "332": "0:0 0:3",
    "334": "0:0 1:0",
    "336": "0:0 1:1",
    "338": "0:0 1:2",
    "340": "0:0 2:0",
    "342": "0:0 2:1",
    "344": "0:0 3:0",
    "346": "0:0 4+",
    "348": "0:1 0:1",
    "350": "0:1 0:2",
    "352": "0:1 0:3",
    "354": "0:1 1:1",
    "356": "0:1 1:2",
    "358": "0:1 2:1",
    "360": "0:1 4+",
    "362": "0:2 0:2",
    "364": "0:2 0:3",
    "366": "0:2 1:2",
    "368": "0:2 4+",
    "370": "0:3 0:3",
    "372": "0:3 4+",
    "374": "1:0 1:0",
    "376": "1:0 1:1",
    "378": "1:0 1:2",
    "380": "1:0 2:0",
    "382": "1:0 2:1",
    "384": "1:0 3:0",
    "386": "1:0 4+",
    "388": "1:1 1:1",
    "390": "1:1 1:2",
    "392": "1:1 2:1",
    "394": "1:1 4+",
    "396": "1:2 1:2",
    "398": "1:2 4+",
    "400": "2:0 2:0",
    "402": "2:0 2:1",
    "404": "2:0 3:0",
    "406": "2:0 4+",
    "408": "2:1 2:1",
    "410": "2:1 4+",
    "412": "3:0 3:0",
    "414": "3:0 4+",
    "416": "4+ 4+",
    "name": "ilk yarı/maç sonucu skoru",
    "group": "all|score|regular_play"
  },
  "47": {
    "418": "{$competitor1}/{$competitor1}",
    "420": "{$competitor1}/X",
    "422": "{$competitor1}/{$competitor2}",
    "424": "X/{$competitor1}",
    "426": "X/X",
    "428": "X/{$competitor2}",
    "430": "{$competitor2}/{$competitor1}",
    "432": "{$competitor2}/X",
    "434": "{$competitor2}/{$competitor2}",
    "name": "1.Y/Maç sonucu",
    "group": "all|score|regular_play"
  },
  "48": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor1} her iki devreyi de kazanma",
    "group": "all|score|regular_play"
  },
  "49": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor2} her iki devreyi de kazanma",
    "group": "all|score|regular_play"
  },
  "50": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor1} en az bir yarıyı kazanır",
    "group": "all|score|regular_play"
  },
  "51": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor2} en az bir yarıyı kazanır",
    "group": "all|score|regular_play"
  },
  "52": {
    "436": "1.Y",
    "438": "2.Y",
    "440": "eşit",
    "name": "En fazla gollü devre",
    "group": "all|score|regular_play"
  },
  "53": {
    "436": "1.Y",
    "438": "2.Y",
    "440": "eşit",
    "name": "{$competitor1} en gollü devre",
    "group": "all|score|regular_play"
  },
  "54": {
    "436": "1.Y",
    "438": "2.Y",
    "440": "eşit",
    "name": "{$competitor2} en gollü devre",
    "group": "all|score|regular_play"
  },
  "55": {
    "806": "yok/yok",
    "808": "var/yok",
    "810": "var/var",
    "812": "yok/var",
    "name": "Her iki devrede her iki takımda gol bulur",
    "group": "all|score|regular_play"
  },
  "56": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor1} her iki devrede de gol bulur",
    "group": "all|score|regular_play"
  },
  "57": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor2} her iki devrede de gol bulur",
    "group": "all|score|regular_play"
  },
  "58": {
    "74": "evet",
    "76": "hayır",
    "name": "Her iki yarı {total} +ü",
    "group": "all|score|regular_play"
  },
  "59": {
    "74": "evet",
    "76": "hayır",
    "name": "Her iki yarı {total} -ı",
    "group": "all|score|regular_play"
  },
  "60": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "1.Y - 1x2",
    "group": "all|score|1st_half"
  },
  "61": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Ilk Yari - Sifir skor bahis",
    "group": "all|score|1st_half"
  },
  "62": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "1.Y - {!goalnr} gol",
    "group": "all|score|1st_half"
  },
  "63": {
    "9": "{$competitor1} veya X",
    "10": "{$competitor1} veya {$competitor2}",
    "11": "X veya {$competitor2}",
    "name": "1.Y - çifte şans",
    "group": "all|score|1st_half"
  },
  "64": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "1.Y - beraberlikte iade",
    "group": "all|score|1st_half"
  },
  "65": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "berabere ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "1.Y - handikap {hcp}",
    "group": "all|score|1st_half"
  },
  "66": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "1.Y - handikap",
    "group": "all|score|1st_half"
  },
  "68": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "1.Y - Toplam gol",
    "group": "all|score|1st_half"
  },
  "69": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "1.Y - {$competitor1} toplam gol",
    "group": "all|score|1st_half"
  },
  "70": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "1.Y - {$competitor2} toplam gol",
    "group": "all|score|1st_half"
  },
  "74": {
    "70": "tek",
    "72": "çift",
    "name": "1.Y - tek/çift",
    "group": "all|score|1st_half"
  },
  "75": {
    "74": "evet",
    "76": "hayır",
    "name": "1.Y - her iki takım da gol atar",
    "group": "all|score|1st_half"
  },
  "76": {
    "74": "evet",
    "76": "hayır",
    "name": "1.Y - {$competitor1} gol yemez",
    "group": "all|score|1st_half"
  },
  "77": {
    "74": "evet",
    "76": "hayır",
    "name": "1.Y - {$competitor2} gol yemez",
    "group": "all|score|1st_half"
  },
  "78": {
    "78": "{$competitor1} & var",
    "80": "{$competitor1} & yok",
    "82": "X & var",
    "84": "X & yok",
    "86": "{$competitor2} & var",
    "88": "{$competitor2} & yok",
    "name": "1.Y - 1x2 & her iki takım da gol atar",
    "group": "all|combo|1st_half"
  },
  "79": {
    "794": "{$competitor1} & {total} -ı",
    "796": "{$competitor1} & {total} +ü",
    "798": "X & {total} -ı",
    "800": "X & {total} +ü",
    "802": "{$competitor2} & {total} -ı",
    "804": "{$competitor2} & {total} +ü",
    "name": "ilk yarı - kazanan & gol sayısı",
    "group": "all|combo|1st_half"
  },
  "80": {
    "442": "0:0",
    "444": "1:0",
    "446": "2:0",
    "448": "3:0",
    "450": "0:1",
    "452": "1:1",
    "454": "2:1",
    "456": "0:2",
    "458": "1:2",
    "460": "0:3",
    "name": "1.Y -  skor {!score}",
    "group": "all|score|1st_half"
  },
  "81": {
    "462": "0:0",
    "464": "1:1",
    "466": "2:2",
    "468": "1:0",
    "470": "2:0",
    "472": "2:1",
    "474": "0:1",
    "476": "0:2",
    "478": "1:2",
    "480": "diğer",
    "name": "1.Y -  skor",
    "group": "all|score|1st_half"
  },
  "83": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "2.Y - 1x2",
    "group": "all|score|2nd_half"
  },
  "84": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "ikinci yarı - {!goalnr} gol",
    "group": "all|score|2nd_half"
  },
  "85": {
    "9": "{$competitor1} veya X",
    "10": "{$competitor1} veya {$competitor2}",
    "11": "X veya {$competitor2}",
    "name": "2.Y - çifte şans",
    "group": "all|score|2nd_half"
  },
  "86": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "2.Y - beraberlikte iade",
    "group": "all|score|2nd_half"
  },
  "87": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "berabere ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "2.Y - handikap {hcp}",
    "group": "all|score|2nd_half"
  },
  "88": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "2.Y - handikap",
    "group": "all|score|2nd_half"
  },
  "90": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "2.Y - toplam gol",
    "group": "all|score|2nd_half"
  },
  "91": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "2.Y - {$competitor1} toplam gol",
    "group": "all|score|2nd_half"
  },
  "92": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "2.Y - {$competitor2} toplam gol",
    "group": "all|score|2nd_half"
  },
  "94": {
    "70": "tek",
    "72": "çift",
    "name": "2.Y - tek/çift",
    "group": "all|score|2nd_half"
  },
  "95": {
    "74": "evet",
    "76": "hayır",
    "name": "2.Y - her iki takım da gol atar",
    "group": "all|score|2nd_half"
  },
  "96": {
    "74": "evet",
    "76": "hayır",
    "name": "2.Y - {$competitor1} gol yemez",
    "group": "all|score|2nd_half"
  },
  "97": {
    "74": "evet",
    "76": "hayır",
    "name": "2.Y - {$competitor2} gol yemez",
    "group": "all|score|2nd_half"
  },
  "98": {
    "546": "0:0",
    "548": "0:1",
    "550": "0:2",
    "552": "1:0",
    "554": "1:1",
    "556": "1:2",
    "558": "2:0",
    "560": "2:1",
    "562": "2:2",
    "564": "diğer",
    "name": "ikinci yarı - skor",
    "group": "all|score|2nd_half"
  },
  "100": {
    "584": "1-15",
    "586": "16-30",
    "588": "31-45",
    "590": "46-60",
    "592": "61-75",
    "594": "76-90",
    "596": "Gol olmaz",
    "name": "{!goalnr} gol ne zaman atılır (15 dakikalık aralıkla)",
    "group": "all|score|regular_play"
  },
  "101": {
    "598": "1-10",
    "600": "11-20",
    "602": "21-30",
    "604": "31-40",
    "606": "41-50",
    "608": "51-60",
    "610": "61-70",
    "612": "71-80",
    "614": "81-90",
    "616": "Gol olmaz",
    "name": "{!goalnr} gol ne zaman atılır (10 dakikalık aralıkla)",
    "group": "all|score|regular_play"
  },
  "102": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "15 dakika - 1x2 {from}dan {to}a kadar",
    "group": "all|score|15_min"
  },
  "103": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "15 dakika - {!goalnr} gol {from} den {to} a",
    "group": "all|score|15_min"
  },
  "104": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "15 dakika - {from}dan {to}a kadar toplam gol",
    "group": "all|score|15_min"
  },
  "105": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "10 dakika - 1x2 {from}dan {to}a kadar",
    "group": "all|score|10_min"
  },
  "106": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "10 dakika - {!goalnr} gol {from} den {to} a",
    "group": "all|score|10_min"
  },
  "107": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "10 dakika -{from}dan {to}a kadar toplam gol",
    "group": "all|score|10_min"
  },
  "108": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "5 dakika - 1x2 {from}dan {to}a kadar",
    "group": "all|score|5_min"
  },
  "109": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "5 dakika - {!goalnr} gol {from} den {to} a",
    "group": "all|score|5_min"
  },
  "110": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "5 dakika -{from}dan {to}a kadar toplam gol",
    "group": "all|score|5_min"
  },
  "112": {
    "74": "evet",
    "76": "hayır",
    "name": "Uzatma & Gol",
    "group": "all|combo|ot"
  },
  "113": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Uzatmalar - 1x2",
    "group": "all|score|ot"
  },
  "114": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Uzatma - hangi takım kalan sürede kazanacak",
    "group": "all|score|ot"
  },
  "115": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "Uzatma - {!goalnr} gol",
    "group": "all|score|ot"
  },
  "116": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Uzatma - toplam gol",
    "group": "all|score|ot"
  },
  "117": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Uzatma - handikap",
    "group": "all|score|ot"
  },
  "118": {
    "442": "0:0",
    "444": "1:0",
    "446": "2:0",
    "448": "3:0",
    "450": "0:1",
    "452": "1:1",
    "454": "2:1",
    "456": "0:2",
    "458": "1:2",
    "460": "0:3",
    "name": "Uzatma - Doğru skor {!score}",
    "group": "all|score|ot"
  },
  "119": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "İlk uzatma devresi - 1x2",
    "group": "all|score|ot_1st_half"
  },
  "120": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "İlk uzatma devresi - handikap",
    "group": "all|score|ot_1st_half"
  },
  "121": {
    "618": "0:0",
    "620": "1:0",
    "622": "2:0",
    "624": "0:1",
    "626": "1:1",
    "628": "0:2",
    "name": "İlk uzatma devresi - doğru skor {!score}",
    "group": "all|score|ot_1st_half"
  },
  "122": {
    "74": "evet",
    "76": "hayır",
    "name": "Penaltı atışları olacak mı",
    "group": "all|score|incl_ot"
  },
  "123": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Penaltı atışları - kazanan",
    "group": "all|score|pen_so"
  },
  "124": {
    "74": "evet",
    "76": "hayır",
    "name": "Penaltılar - {!penaltynr} penaltı gol olur",
    "group": "all|score|pen_so"
  },
  "125": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "Penaltılar - {!goalnr} gol",
    "group": "all|score|pen_so"
  },
  "126": {
    "630": "{$competitor1} 1 farkla",
    "632": "{$competitor1} 2 farkla",
    "634": "{$competitor1} 3 ve üstü farkla",
    "636": "{$competitor2} 1 farkla",
    "638": "{$competitor2} 2 farkla",
    "640": "{$competitor2} 3 ve üstü farkla",
    "name": "Penaltı atışları - Kazanma farkı",
    "group": "all|score|pen_so"
  },
  "127": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Penaltı atışları - toplam gol",
    "group": "all|score|pen_so"
  },
  "128": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Penaltı atışları - {$competitor1} toplam gol",
    "group": "all|score|pen_so"
  },
  "129": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Penaltı atışları - {$competitor2} toplam gol",
    "group": "all|score|pen_so"
  },
  "131": {
    "70": "tek",
    "72": "çift",
    "name": "Penaltı atışları - tek/çift",
    "group": "all|score|pen_so"
  },
  "132": {
    "70": "tek",
    "72": "çift",
    "name": "Penaltı atışları - {$competitor1} tek/çift",
    "group": "all|score|pen_so"
  },
  "133": {
    "70": "tek",
    "72": "çift",
    "name": "Penaltı atışları - {$competitor2} tek/çift",
    "group": "all|score|pen_so"
  },
  "134": {
    "656": "{$competitor1} & {total} -ı",
    "658": "{$competitor2} & {total} -ı",
    "660": "{$competitor1} & {total} +ü",
    "662": "{$competitor2} & {total} +ü",
    "name": "Penaltılar - kazanan & toplam gol",
    "group": "all|combo|pen_so"
  },
  "135": {
    "1767": "0:1",
    "1768": "0:2",
    "1769": "0:3",
    "1770": "1:0",
    "1771": "1:2",
    "1772": "1:3",
    "1773": "1:4",
    "1774": "2:0",
    "1775": "2:1",
    "1776": "2:3",
    "1777": "2:4",
    "1778": "3:0",
    "1779": "3:1",
    "1780": "3:2",
    "1781": "3:4",
    "1782": "3:5",
    "1783": "4:1",
    "1784": "4:2",
    "1785": "4:3",
    "1786": "4:5",
    "1787": "5:3",
    "1788": "5:4",
    "1789": "diğer",
    "name": "Penaltılar - doğru skor",
    "group": "all|score|pen_so"
  },
  "136": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Kartlar 1x2",
    "group": "all|regular_play|bookings"
  },
  "137": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "{!bookingnr} kart",
    "group": "all|regular_play|bookings"
  },
  "138": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Toplam kart ceza puanı",
    "group": "all|regular_play|bookings"
  },
  "139": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Toplam kart sayısı",
    "group": "all|regular_play|bookings"
  },
  "140": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{$competitor1} toplam kart sayısı",
    "group": "all|regular_play|bookings"
  },
  "141": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{$competitor2} toplam kart sayısı",
    "group": "all|regular_play|bookings"
  },
  "142": {
    "710": "0-3",
    "712": "4",
    "714": "5",
    "716": "6",
    "718": "7",
    "720": "8",
    "722": "9",
    "724": "10",
    "726": "11",
    "728": "12+",
    "name": "Doğru kart sayısı",
    "group": "all|regular_play|bookings"
  },
  "143": {
    "730": "0-1",
    "732": "2",
    "734": "3",
    "736": "4+",
    "name": "{$competitor1} doğru kart sayısı",
    "group": "all|regular_play|bookings"
  },
  "144": {
    "730": "0-1",
    "732": "2",
    "734": "3",
    "736": "4+",
    "name": "{$competitor2} toplam kart sayısı",
    "group": "all|regular_play|bookings"
  },
  "146": {
    "74": "evet",
    "76": "hayır",
    "name": "Oyundan atılma",
    "group": "all|regular_play|bookings"
  },
  "147": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor1} takımında oyundan atılan olur",
    "group": "all|regular_play|bookings"
  },
  "148": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor2} takımında oyundan atılan olur",
    "group": "all|regular_play|bookings"
  },
  "149": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "1.Y - kartlar 1x2",
    "group": "all|1st_half|bookings"
  },
  "150": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "1.Y - {!bookingnr} kart",
    "group": "all|1st_half|bookings"
  },
  "151": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "1.Y - toplam kart ceza puanı",
    "group": "all|1st_half|bookings"
  },
  "152": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "1.Y - toplam kart sayısı",
    "group": "all|1st_half|bookings"
  },
  "153": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "1.Y - {$competitor1} kart sayısı",
    "group": "all|1st_half|bookings"
  },
  "154": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "1.Y - {$competitor2} kart sayısı",
    "group": "all|1st_half|bookings"
  },
  "155": {
    "1760": "0",
    "1761": "1",
    "1762": "2",
    "1763": "3",
    "1764": "4",
    "1765": "5",
    "1766": "6+",
    "name": "1.Y - doğru kart sayısı",
    "group": "all|1st_half|bookings"
  },
  "156": {
    "54": "0",
    "56": "1",
    "58": "2",
    "60": "3+",
    "name": "1.Y - {$competitor1} doğru kart sayısı",
    "group": "all|1st_half|bookings"
  },
  "157": {
    "54": "0",
    "56": "1",
    "58": "2",
    "60": "3+",
    "name": "1.Y - {$competitor2} doğru kart sayısı",
    "group": "all|1st_half|bookings"
  },
  "159": {
    "74": "evet",
    "76": "hayır",
    "name": "1.Y - oyundan atılma",
    "group": "all|1st_half|bookings"
  },
  "160": {
    "74": "evet",
    "76": "hayır",
    "name": "1.Y - {$competitor1} oyundan atılma",
    "group": "all|1st_half|bookings"
  },
  "161": {
    "74": "evet",
    "76": "hayır",
    "name": "1.Y - {$competitor2} oyundan atılma",
    "group": "all|1st_half|bookings"
  },
  "162": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Korner 1x2",
    "group": "all|regular_play|corners"
  },
  "163": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "{!cornernr} korner",
    "group": "all|regular_play|corners"
  },
  "164": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "Son korner",
    "group": "all|regular_play|corners"
  },
  "165": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Korner handikap",
    "group": "all|regular_play|corners"
  },
  "166": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Toplam korner sayısı",
    "group": "all|regular_play|corners"
  },
  "167": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{$competitor1} toplam kornerler",
    "group": "all|regular_play|corners"
  },
  "168": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{$competitor2} toplam korner sayısı",
    "group": "all|regular_play|corners"
  },
  "172": {
    "70": "tek",
    "72": "çift",
    "name": "tek/çift kornerler",
    "group": "all|regular_play|corners"
  },
  "173": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "1.Y - korner 1x2",
    "group": "all|1st_half|corners"
  },
  "174": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "1.Y - {!cornernr} korner",
    "group": "all|1st_half|corners"
  },
  "175": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "1.Y - son korner",
    "group": "all|1st_half|corners"
  },
  "176": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "1.Y - korner handikap",
    "group": "all|1st_half|corners"
  },
  "177": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "1.Y - toplam korner sayısı",
    "group": "all|1st_half|corners"
  },
  "178": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "1.Y - {$competitor1} toplam korner sayısı",
    "group": "all|1st_half|corners"
  },
  "179": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "1.Y - {$competitor2} toplam korner sayısı",
    "group": "all|1st_half|corners"
  },
  "180": {
    "730": "0-1",
    "732": "2",
    "734": "3",
    "736": "4+",
    "name": "1.Y - {$competitor1} doğru korner sayısı",
    "group": "all|1st_half|corners"
  },
  "181": {
    "730": "0-1",
    "732": "2",
    "734": "3",
    "736": "4+",
    "name": "1.Y - {$competitor2} doğru korner sayısı",
    "group": "all|1st_half|corners"
  },
  "183": {
    "70": "tek",
    "72": "çift",
    "name": "1.Y - tek/çift kornerler",
    "group": "all|1st_half|corners"
  },
  "184": {
    "814": "{$competitor1} golü & {$competitor1} kazanır",
    "816": "{$competitor1} golü & beraberlik",
    "818": "{$competitor1} golü & {$competitor2} kazanır",
    "820": "{$competitor2} golü & {$competitor1} kazanır",
    "822": "{$competitor2} golü & beraberlik",
    "824": "{$competitor2} golü & {$competitor2} kazanır",
    "826": "gol yok",
    "name": "{!goalnr} gol & 1x2",
    "group": "all|regular_play|combo"
  },
  "186": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Kazanan",
    "group": "all|score|regular_play"
  },
  "187": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Toplam oyun handikapı",
    "group": "all|score|regular_play"
  },
  "188": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Handikaplı set",
    "group": "all|score|regular_play"
  },
  "189": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Maç sonu toplam oyun",
    "group": "all|score|regular_play"
  },
  "190": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{$competitor1} toplam oyun",
    "group": "all|score|regular_play"
  },
  "191": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{$competitor2} toplam oyun",
    "group": "all|score|regular_play"
  },
  "192": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor1} set kazanır",
    "group": "all|score|regular_play"
  },
  "193": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor2} set kazanır",
    "group": "all|score|regular_play"
  },
  "194": {
    "74": "evet",
    "76": "hayır",
    "name": "Sıfıra karşı herhangi set",
    "group": "all|score|regular_play"
  },
  "195": {
    "74": "evet",
    "76": "hayır",
    "name": "Tiebreak olacak mı",
    "group": "all|score|regular_play"
  },
  "198": {
    "70": "tek",
    "72": "çift",
    "name": "Toplam oyun tek/çift",
    "group": "all|score|regular_play"
  },
  "201": {
    "861": "{$competitor1}/{$competitor1}",
    "862": "{$competitor2}/{$competitor1}",
    "863": "{$competitor1}/{$competitor2}",
    "864": "{$competitor2}/{$competitor2}",
    "name": "Çifte sonuç bahisi (İlk set/maç)",
    "group": "all|score|regular_play"
  },
  "202": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr}. set - kazananı",
    "group": "all|score|set"
  },
  "203": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!setnr}. set - oyun handikapı",
    "group": "all|score|set"
  },
  "204": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!setnr}. set - toplam oyun",
    "group": "all|score|set"
  },
  "205": {
    "70": "tek",
    "72": "çift",
    "name": "{!setnr}. set - tek/çift oyunlar",
    "group": "all|score|set"
  },
  "206": {
    "74": "evet",
    "76": "hayır",
    "name": "{!setnr}. set - tiebreak olacak mı",
    "group": "all|score|set"
  },
  "207": {
    "865": "6:0",
    "866": "6:1",
    "867": "6:2",
    "868": "6:3",
    "869": "6:4",
    "870": "7:5",
    "871": "7:6",
    "872": "0:6",
    "873": "1:6",
    "874": "2:6",
    "875": "3:6",
    "876": "4:6",
    "877": "5:7",
    "878": "6:7",
    "name": "{!setnr}. set - doğru skor",
    "group": "all|score|set"
  },
  "208": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr}. set - {games} oyun çekişmesi",
    "group": "all|score|set"
  },
  "209": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!setnr}. set - {!gamenrX}. ve {!gamenrY}. oyunların kazananı",
    "group": "all|score|game"
  },
  "210": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr}. set {gamenr}. oyun - kazanan",
    "group": "all|score|game"
  },
  "211": {
    "882": "4",
    "883": "5",
    "884": "6",
    "885": "7+",
    "name": "{!setnr}. set {gamenr}. oyun - doğru skor",
    "group": "all|score|game"
  },
  "212": {
    "74": "evet",
    "76": "hayır",
    "name": "{!setnr}. set {gamenr}. oyun - eşitlik",
    "group": "all|score|game"
  },
  "213": {
    "70": "tek",
    "72": "çift",
    "name": "{!setnr}. set {gamenr}. oyun  - tek/çift sayı",
    "group": "all|score|game"
  },
  "214": {
    "886": "{$competitor1} 0a karşı",
    "887": "{$competitor1} 15e karşı",
    "888": "{$competitor1} 30a karşı",
    "889": "{$competitor1} 40a karşı",
    "890": "{$competitor2} 0a karşı",
    "891": "{$competitor2} 15e karşı",
    "892": "{$competitor2} 30a karşı",
    "893": "{$competitor2} 40a karşı",
    "name": "{!setnr}. set {gamenr}. oyun - doğru skor",
    "group": "all|score|game"
  },
  "215": {
    "894": "{%server} e 0",
    "895": "{%server} e 15",
    "896": "{%server} e 30",
    "897": "{%server} e 40",
    "898": "mola",
    "name": "{!setnr}. set {gamenr}. oyun - doğru skor yada break",
    "group": "all|score|game"
  },
  "216": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr}. set {gamenr}. oyun - {pointnr}. sayının çekişmesi",
    "group": "all|score|points"
  },
  "217": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!setnr}. set {gamenr}. oyun - ilk {pointnr} sayının kazananı",
    "group": "all|score|points"
  },
  "218": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr}. set {gamenr}. oyun - {!pointnr}. sayı",
    "group": "all|score|points"
  },
  "219": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Kazanan (uzatmalar dahil)",
    "group": "all|score|incl_ot"
  },
  "220": {
    "74": "evet",
    "76": "hayır",
    "name": "Uzatma olacak mı",
    "group": "all|score|regular_play"
  },
  "221": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "{!scorenr} skor (uzatmalar dahil)",
    "group": "all"
  },
  "222": {
    "901": "gol",
    "902": "alan golü",
    "903": "diğer",
    "904": "Gol olmaz",
    "name": "{!scorenr}. sayı yapma şekli (uzatmalar dahil)",
    "group": "all"
  },
  "223": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Handikap (uzatmalar dahil)",
    "group": "all|score|incl_ot"
  },
  "224": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "US spread (uzatmalar dahil)",
    "group": "all|score|incl_ot"
  },
  "225": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Toplam (uzatmalar dahil)",
    "group": "all|score|incl_ot"
  },
  "226": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Us toplam gol (uzatmalar dahil)",
    "group": "all|score|incl_ot"
  },
  "227": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{$competitor1} toplam gol (uzatmalar dahil)",
    "group": "all|score|incl_ot"
  },
  "228": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{$competitor2} toplam gol (uzatmalar dahil)",
    "group": "all|score|incl_ot"
  },
  "229": {
    "70": "tek",
    "72": "çift",
    "name": "tek/çift (uzatmalar dahil)",
    "group": "all|score|incl_ot"
  },
  "230": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{pointnr}. sayı çekişmesi (uzatmalar dahil)",
    "group": "all|score|incl_ot"
  },
  "231": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "2.Y - handikap (uzatmalar dahil)",
    "group": "all|score|combo|incl_ot|2nd_half_incl_ot"
  },
  "232": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "2.Y - toplam gol (uzatmalar dahil)",
    "group": "all|score|combo|incl_ot|2nd_half_incl_ot"
  },
  "234": {
    "920": "İlk çeyrek",
    "921": "İkinci çeyrek",
    "922": "Üçüncü çeyrek",
    "923": "Dördüncü çeyrek",
    "924": "eşit",
    "name": "En fazla sayı olan çeyrek",
    "group": "all|score|regular_play"
  },
  "235": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!quarternr}. çeyrek - 1x2",
    "group": "all|score|quarter"
  },
  "236": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!quarternr}. çeyrek - toplam gol",
    "group": "all|score|quarter"
  },
  "237": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Sayı handikap",
    "group": "all|score|regular_play"
  },
  "238": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Toplam sayı",
    "group": "all|score|regular_play"
  },
  "245": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!gamenr}. oyun - kazanan",
    "group": "all|score|game"
  },
  "246": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!gamenr}. oyun - handikaplı sayı",
    "group": "all|score|game"
  },
  "247": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!gamenr}. oyun - toplam sayı",
    "group": "all|score|game"
  },
  "248": {
    "70": "tek",
    "72": "çift",
    "name": "{!gamenr}. oyun - tek/çift",
    "group": "all|score|game"
  },
  "250": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!gamenr}. oyun - {pointnr}. sayı çekişmesi",
    "group": "all|score|game"
  },
  "251": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Kazanan (uzatmalar dahil)",
    "group": "all|score|incl_ei"
  },
  "252": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "1x2 (uzatmalar dahil)",
    "group": "all"
  },
  "253": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Maçın kalanını hangi takım kazanır (uzatmalar dahil)",
    "group": "all|score|incl_ei"
  },
  "254": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "berabere ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "Handikap {hcp} (uzatmalar dahil)",
    "group": "all|score|incl_ei"
  },
  "255": {
    "630": "{$competitor1} 1 farkla",
    "632": "{$competitor1} 2 farkla",
    "634": "{$competitor1} 3 ve üstü farkla",
    "636": "{$competitor2} 1 farkla",
    "638": "{$competitor2} 2 farkla",
    "640": "{$competitor2} 3 ve üstü farkla",
    "name": "Kazanma farkı (uzatmalar dahil)",
    "group": "all|score|incl_ei"
  },
  "256": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Handikap (uzatmalar dahil)",
    "group": "all|score|incl_ei"
  },
  "257": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "US spread (uzatma devreleri dahil)",
    "group": "all|score|incl_ei"
  },
  "258": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Toplam (uzatmalar dahil)",
    "group": "all|score|incl_ei"
  },
  "259": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "US Üst/Alt (uzatma devreleri dahil)",
    "group": "all|score|incl_ei"
  },
  "260": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{$competitor1} toplam (uzatmalar dahil)",
    "group": "all|score|incl_ei"
  },
  "261": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{$competitor2} toplam (uzatmalar dahil)",
    "group": "all|score|incl_ei"
  },
  "262": {
    "939": "{total} -ında",
    "940": "tam {total}",
    "941": "{total} +ünde",
    "name": "Toplam (üst-tam-alt) (uzatmalar dahil)",
    "group": "all|score|incl_ei"
  },
  "264": {
    "70": "tek",
    "72": "çift",
    "name": "Tek/çift (uzatmalar dahil)",
    "group": "all|score|incl_ei"
  },
  "265": {
    "794": "{$competitor1} & {total} -ı",
    "796": "{$competitor1} & {total} +ü",
    "798": "X & {total} -ı",
    "800": "X & {total} +ü",
    "802": "{$competitor2} & {total} -ı",
    "804": "{$competitor2} & {total} +ü",
    "name": "1x2 & toplam (uzatmalar dahil)",
    "group": "all|combo|incl_ei"
  },
  "266": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "{!runnr}. koşu (uzatmalar dahil)",
    "group": "all|score|incl_ei"
  },
  "267": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{runnr}. koşunun çekişmesi (uzatmalar dahil)",
    "group": "all|score|incl_ei"
  },
  "268": {
    "74": "evet",
    "76": "hayır",
    "name": "Uzatma devresi olucak mı",
    "group": "all|score|regular_play"
  },
  "269": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor1}ın 9. devredeki vuruşu",
    "group": "all|score|regular_play"
  },
  "270": {
    "948": "{$competitor1}",
    "949": "X",
    "950": "{$competitor2}",
    "name": "Daha çok devre kazanacak takım",
    "group": "all|score|regular_play"
  },
  "271": {
    "948": "{$competitor1}",
    "949": "X",
    "950": "{$competitor2}",
    "name": "En çok skorun olduğu devreyi kazanan takım",
    "group": "all|score|regular_play"
  },
  "272": {
    "951": "1. devre",
    "952": "2. devre",
    "953": "3. devre",
    "954": "4. devre",
    "955": "5. devre",
    "956": "6. devre",
    "957": "7. devre",
    "958": "8. devre",
    "959": "9. devre",
    "960": "eşit",
    "name": "En çok skorun olduğu devre",
    "group": "all|score|regular_play"
  },
  "273": {
    "961": "0",
    "962": "1",
    "963": "2",
    "964": "3",
    "965": "4",
    "966": "5+",
    "name": "En yüksek skorlu devredeki koşu sayısı",
    "group": "all|score|regular_play"
  },
  "274": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Devreler 1 den 5 e - 1x2",
    "group": "all|score|5_innings"
  },
  "275": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Devreler 1 den 5 e - handikap",
    "group": "all|score|5_innings"
  },
  "276": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Devreler 1 den 5 e - toplam",
    "group": "all|score|5_innings"
  },
  "277": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Devreler 1 den 5 e - {$competitor1} toplam",
    "group": "all|score|5_innings"
  },
  "278": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Devreler 1 den 5 e - {$competitor2} toplam",
    "group": "all|score|5_innings"
  },
  "279": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Devreler 1den 5in sonuna - 1x2",
    "group": "all|score|4.5_innings"
  },
  "280": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Devreler 1den 5in sonuna - handikap",
    "group": "all|score|4.5_innings"
  },
  "281": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Devreler 1den 5in sonuna - toplam",
    "group": "all|score|4.5_innings"
  },
  "282": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Devreler 1den 5in sonuna - {$competitor1} toplam",
    "group": "all|score|4.5_innings"
  },
  "283": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Devreler 1den 5in sonuna - {$competitor2} toplam",
    "group": "all|score|4.5_innings"
  },
  "284": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Devreler {from} den {to} e - toplam",
    "group": "all|score|3_innings"
  },
  "285": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Devreler {from} den {to} e - {$competitor1} toplam",
    "group": "all|score|3_innings"
  },
  "286": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Devreler {from} den {to} e - {$competitor2} toplam",
    "group": "all|score|3_innings"
  },
  "287": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!inningnr}. devre - 1x2",
    "group": "all|score|inning"
  },
  "288": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr}. devre - toplam",
    "group": "all|score|inning"
  },
  "289": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Hava atışını hangi takım kazanır",
    "group": "all|misc"
  },
  "291": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!pointnr}. sayı (uzatmalar dahil)",
    "group": "all|score|incl_ot"
  },
  "292": {
    "973": "{$competitor1} & {total} +ü",
    "974": "{$competitor2} & {total} +ü",
    "975": "{$competitor1} & {total} -ı",
    "976": "{$competitor2} & {total} -ı",
    "name": "Kazanan & toplam gol (uzatmalar dahil)",
    "group": "all|combo|incl_ot"
  },
  "293": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "2.Y - 1x2 (uzatmalar dahil)",
    "group": "all|score|combo|incl_ot|2nd_half_incl_ot"
  },
  "294": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "2.Y - beraberlikte iade (uzatmalar dahil)",
    "group": "all|score|combo|incl_ot|2nd_half_incl_ot"
  },
  "295": {
    "70": "tek",
    "72": "çift",
    "name": "2.Y - tek/çift (uzatma dahil)",
    "group": "all|score|combo|incl_ot|2nd_half_incl_ot"
  },
  "297": {
    "939": "{total} -ında",
    "940": "tam {total}",
    "941": "{total} +ünde",
    "name": "Toplam gol (üstünde-tam olarak-altında)",
    "group": "all|score|regular_play"
  },
  "300": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{pointnr}. sayının çekişmesi",
    "group": "all|score|regular_play"
  },
  "301": {
    "1002": "{$competitor1} 3 ve üstü farkla",
    "1003": "{$competitor2} 3 ve üstü farkla",
    "1004": "diğer",
    "name": "{!quarternr} çeyrek - Kazanma farkı",
    "group": "all|score|quarter"
  },
  "302": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!quarternr}. çeyrek - beraberlikte iade",
    "group": "all|score|quarter"
  },
  "303": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!quarternr} çeyrek - handikap",
    "group": "all|score|quarter"
  },
  "304": {
    "70": "tek",
    "72": "çift",
    "name": "{!quarternr} çeyrek - tek/çift",
    "group": "all|score|quarter"
  },
  "305": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!quarternr}. çeyrek - {pointnr} sayıya ilk ulaşacak olan",
    "group": "all|score|quarter"
  },
  "309": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!setnr}. set - handikatp sayı",
    "group": "all|score|set"
  },
  "310": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!setnr}. set - toplam sayı",
    "group": "all|score|set"
  },
  "311": {
    "70": "tek",
    "72": "çift",
    "name": "{!setnr}. set - tek/çift",
    "group": "all|score|set"
  },
  "312": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr}. set - {!pointnr}. sayı",
    "group": "all|score|set"
  },
  "313": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr}. set - {pointnr}. sayının çekişmesi",
    "group": "all|score|set"
  },
  "314": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Toplam set",
    "group": "all|score|regular_play"
  },
  "315": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!setnr}. set - 1x2",
    "group": "all|score|set"
  },
  "316": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr}. set - beraberlikte iade",
    "group": "all|score|set"
  },
  "317": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "berabere ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "{!setnr}. set - handikap {hcp}",
    "group": "all|score|set"
  },
  "318": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!setnr}. set - {$competitor1}  toplam",
    "group": "all|score|set"
  },
  "319": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!setnr}. set - {$competitor2}  toplam",
    "group": "all|score|set"
  },
  "322": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr}. set {endnr}. end - kazanan",
    "group": "all|score|end"
  },
  "323": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!setnr}. set {endnr}. end - toplam",
    "group": "all|score|end"
  },
  "324": {
    "1005": "0",
    "1006": "1",
    "1007": "2",
    "1008": "3",
    "1009": "4",
    "name": "{!setnr}. set {endnr}. end - doğru skor",
    "group": "all|score|end"
  },
  "325": {
    "70": "tek",
    "72": "çift",
    "name": "{!setnr}. set {endnr}. end - tek/çift",
    "group": "all|score|end"
  },
  "326": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "berabere ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "Harita handikapı {hcp}",
    "group": "all|score|regular_play"
  },
  "327": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Harita handikapı",
    "group": "all|score|regular_play"
  },
  "328": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Toplam harita",
    "group": "all|score|regular_play"
  },
  "330": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{mapnr}. harita - kazanan (uzatma süreleri dahil)",
    "group": "all|score|map_incl_ot"
  },
  "331": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{mapnr}. harita - raund handikapı (uzatma süreleri dahil)",
    "group": "all|score|map_incl_ot"
  },
  "332": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{mapnr}. harita - toplam raund ( uzatma süreleri dahil)",
    "group": "all|score|map_incl_ot"
  },
  "333": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{mapnr}. harita - {xth}. kill",
    "group": "all|kills|map"
  },
  "334": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!mapnr}. map - 1x2",
    "group": "all|score|map"
  },
  "335": {
    "74": "evet",
    "76": "hayır",
    "name": "{!mapnr}. harita - uzatma süresi olur",
    "group": "all|score|map"
  },
  "337": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr}. harita bıçak raundu - kazanan",
    "group": "all|round"
  },
  "338": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr}. harita {roundnr}. raund - kazanan",
    "group": "all|round"
  },
  "340": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Kazanan (super over dahil)",
    "group": "all|score|incl_so"
  },
  "341": {
    "74": "evet",
    "76": "hayır",
    "name": "Super over olur mu",
    "group": "all|score|regular_play"
  },
  "342": {
    "74": "evet",
    "76": "hayır",
    "name": "Tie olur mu",
    "group": "all|score|regular_play"
  },
  "343": {
    "1031": "yakalama",
    "1032": "bowled",
    "1033": "lbw",
    "1034": "run out",
    "1035": "stumped",
    "1036": "diğerleri",
    "name": "{!inningnr}. devre - {!dismissalnr}. oyundan çıkarılma methodu",
    "group": "all|dismissal|innings"
  },
  "344": {
    "1037": "yakalar",
    "1038": "yakalayamaz",
    "name": "{!inningnr}. devre - {!dismissalnr}. oyundan çıkarılma methodu (sınırlı)",
    "group": "all|dismissal|innings"
  },
  "347": {
    "948": "{$competitor1}",
    "949": "X",
    "950": "{$competitor2}",
    "name": "{!inningnr}. devre - en çok skor üstü yapan takım",
    "group": "all|score|innings"
  },
  "349": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr}. devre - {$competitor1} toplam {!dismissalnr}. oyundan çıkarılma",
    "group": "all|score|innings"
  },
  "350": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr}. devre - {$competitor2} toplam {!dismissalnr}. oyundan çıkarılma",
    "group": "all|score|innings"
  },
  "351": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!inningnr}. devre 0 a {overnr}. over - 1x2",
    "group": "all|score|x_overs"
  },
  "352": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr}. devre 0 a {overnr}. over -{$competitor1} toplam",
    "group": "all|score|x_overs"
  },
  "353": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr}. devre 0 a {overnr}. over -{$competitor2} toplam",
    "group": "all|score|x_overs"
  },
  "356": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr}. devre {overnr}. over - {$competitor1} toplam",
    "group": "all|score|over"
  },
  "357": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr}. devre {overnr}. over - {$competitor2} toplam",
    "group": "all|score|over"
  },
  "358": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Birinci over - toplam",
    "group": "all|score|over"
  },
  "359": {
    "70": "tek",
    "72": "çift",
    "name": "{!inningnr}. devre {overnr}. over - {$competitor1} tek/çift",
    "group": "all|score|over"
  },
  "360": {
    "70": "tek",
    "72": "çift",
    "name": "{!inningnr}. devre {overnr}. over - {$competitor2} tek/çift",
    "group": "all|score|over"
  },
  "361": {
    "70": "tek",
    "72": "çift",
    "name": "Birinci over - tek/çift",
    "group": "all|score|over"
  },
  "362": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr}. devre {overnr}. over - {!deliverynr}. delivery {$competitor1} toplam",
    "group": "all|score|delivery"
  },
  "363": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr}. devre {overnr}. over - {!deliverynr}. delivery {$competitor2} toplam",
    "group": "all|score|delivery"
  },
  "365": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "berabere ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "Set handikapı {hcp}",
    "group": "all|score|regular_play"
  },
  "366": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Ayak handikabı",
    "group": "all|score|regular_play"
  },
  "367": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Toplam ayak",
    "group": "all|score|regular_play"
  },
  "368": {
    "70": "tek",
    "72": "çift",
    "name": "Tek/çift setler",
    "group": "all|score|regular_play"
  },
  "370": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!setnr}. set - Kalanı hangi oyuncu kazanır",
    "group": "all|score|set"
  },
  "371": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!setnr}. set - ayak handikabı",
    "group": "all|score|set"
  },
  "372": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!setnr}. set - toplam ayak",
    "group": "all|score|set"
  },
  "373": {
    "70": "tek",
    "72": "çift",
    "name": "{!setnr}. set - tek/çift ayak",
    "group": "all|score|set"
  },
  "375": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr}. set {legnr}. ayak- kazanan",
    "group": "all|score|leg"
  },
  "376": {
    "1039": "{total} +ü",
    "1040": "{total} -ı",
    "name": "{!setnr}. set {legnr}. ayak- toplam dart",
    "group": "all|score|leg"
  },
  "377": {
    "1041": "{$competitor1}",
    "1042": "{$competitor2}",
    "1043": "X",
    "name": "{!setnr}. set {legnr}. ayak- {!visitnr}. visitte en yüksek skoru yapan oyuncu",
    "group": "all|score|visit"
  },
  "378": {
    "1044": "0-89",
    "1045": "90-100",
    "1046": "101+",
    "name": "{!setnr}. set {legnr}. ayak- {!visitnr}. visitte sayı aralığı",
    "group": "all|score|visit"
  },
  "379": {
    "74": "evet",
    "76": "hayır",
    "name": "{!setnr}.. set {legnr}. ayak - checkout skor {score}+",
    "group": "all|leg|checkout"
  },
  "380": {
    "1049": "kırmızı",
    "1050": "yeşil",
    "name": "{!setnr}.. set {legnr}. ayak - checkout renk",
    "group": "all|leg|checkout"
  },
  "381": {
    "1041": "{$competitor1}",
    "1042": "{$competitor2}",
    "1043": "X",
    "name": "En çok 180",
    "group": "all|regular_play|180s"
  },
  "382": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "{!xth}. oyuncu 180 puan yapar",
    "group": "all|regular_play|180s"
  },
  "383": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "180 handikapı",
    "group": "all|regular_play|180s"
  },
  "384": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Toplam 180ler",
    "group": "all|regular_play|180s"
  },
  "385": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{$competitor1} toplam 180ler",
    "group": "all|regular_play|180s"
  },
  "386": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{$competitor2} toplam 180ler",
    "group": "all|regular_play|180s"
  },
  "387": {
    "1041": "{$competitor1}",
    "1042": "{$competitor2}",
    "1043": "X",
    "name": "{!setnr}. set - en çok yapılıcak 180",
    "group": "all|set|180s"
  },
  "388": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!setnr}. set - toplam 180ler",
    "group": "all|set|180s"
  },
  "389": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!setnr}. set - {$competitor1} toplam 180ler",
    "group": "all|set|180s"
  },
  "390": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!setnr}. set - {$competitor2} toplam 180ler",
    "group": "all|set|180s"
  },
  "391": {
    "74": "evet",
    "76": "hayır",
    "name": "{!setnr}. set {legnr}. ayak - herhangi bir oyuncu 180 yapar",
    "group": "all|leg|180s"
  },
  "392": {
    "74": "evet",
    "76": "hayır",
    "name": "{!setnr}. set {legnr}. ayak - {$competitor1} 180 yapar",
    "group": "all|leg|180s"
  },
  "393": {
    "74": "evet",
    "76": "hayır",
    "name": "{!setnr}. set {legnr}. ayak - {$competitor2} 180 yapar",
    "group": "all|leg|180s"
  },
  "395": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr}. harita - kazanan",
    "group": "all|map"
  },
  "396": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr}. harita - {!xth} kalkan",
    "group": "all|map|structures"
  },
  "397": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr}. harita - {!xth} kule",
    "group": "all|map|structures"
  },
  "398": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr}. harita - {!xth} kışla",
    "group": "all|map|structures"
  },
  "401": {
    "1058": "0:0",
    "1059": "0:1",
    "1060": "0:2",
    "1061": "0:3",
    "1062": "0:4",
    "1063": "0:5",
    "1064": "0:6",
    "1065": "0:7",
    "1066": "0:8",
    "1067": "0:9",
    "1068": "0:10",
    "1069": "0:11",
    "1070": "0:12",
    "1071": "0:13",
    "1072": "0:14",
    "1073": "0:15",
    "1074": "0:16",
    "1075": "0:17",
    "1076": "0:18",
    "1077": "0:19",
    "1078": "1:0",
    "1079": "1:1",
    "1080": "1:2",
    "1081": "1:3",
    "1082": "1:4",
    "1083": "1:5",
    "1084": "1:6",
    "1085": "1:7",
    "1086": "1:8",
    "1087": "1:9",
    "1088": "1:10",
    "1089": "1:11",
    "1090": "1:12",
    "1091": "1:13",
    "1092": "1:14",
    "1093": "1:15",
    "1094": "1:16",
    "1095": "1:17",
    "1096": "1:18",
    "1097": "1:19",
    "1098": "2:0",
    "1099": "2:1",
    "1100": "2:2",
    "1101": "2:3",
    "1102": "2:4",
    "1103": "2:5",
    "1104": "2:6",
    "1105": "2:7",
    "1106": "2:8",
    "1107": "2:9",
    "1108": "2:10",
    "1109": "2:11",
    "1110": "2:12",
    "1111": "2:13",
    "1112": "2:14",
    "1113": "2:15",
    "1114": "2:16",
    "1115": "2:17",
    "1116": "2:18",
    "1117": "2:19",
    "1118": "3:0",
    "1119": "3:1",
    "1120": "3:2",
    "1121": "3:3",
    "1122": "3:4",
    "1123": "3:5",
    "1124": "3:6",
    "1125": "3:7",
    "1126": "3:8",
    "1127": "3:9",
    "1128": "3:10",
    "1129": "3:11",
    "1130": "3:12",
    "1131": "3:13",
    "1132": "3:14",
    "1133": "3:15",
    "1134": "3:16",
    "1135": "3:17",
    "1136": "3:18",
    "1137": "3:19",
    "1138": "4:0",
    "1139": "4:1",
    "1140": "4:2",
    "1141": "4:3",
    "1142": "4:4",
    "1143": "4:5",
    "1144": "4:6",
    "1145": "4:7",
    "1146": "4:8",
    "1147": "4:9",
    "1148": "4:10",
    "1149": "4:11",
    "1150": "4:12",
    "1151": "4:13",
    "1152": "4:14",
    "1153": "4:15",
    "1154": "4:16",
    "1155": "4:17",
    "1156": "4:18",
    "1157": "4:19",
    "1158": "5:0",
    "1159": "5:1",
    "1160": "5:2",
    "1161": "5:3",
    "1162": "5:4",
    "1163": "5:5",
    "1164": "5:6",
    "1165": "5:7",
    "1166": "5:8",
    "1167": "5:9",
    "1168": "5:10",
    "1169": "5:11",
    "1170": "5:12",
    "1171": "5:13",
    "1172": "5:14",
    "1173": "5:15",
    "1174": "5:16",
    "1175": "5:17",
    "1176": "5:18",
    "1177": "5:19",
    "1178": "6:0",
    "1179": "6:1",
    "1180": "6:2",
    "1181": "6:3",
    "1182": "6:4",
    "1183": "6:5",
    "1184": "6:6",
    "1185": "6:7",
    "1186": "6:8",
    "1187": "6:9",
    "1188": "6:10",
    "1189": "6:11",
    "1190": "6:12",
    "1191": "6:13",
    "1192": "6:14",
    "1193": "6:15",
    "1194": "6:16",
    "1195": "6:17",
    "1196": "6:18",
    "1197": "6:19",
    "1198": "7:0",
    "1199": "7:1",
    "1200": "7:2",
    "1201": "7:3",
    "1202": "7:4",
    "1203": "7:5",
    "1204": "7:6",
    "1205": "7:7",
    "1206": "7:8",
    "1207": "7:9",
    "1208": "7:10",
    "1209": "7:11",
    "1210": "7:12",
    "1211": "7:13",
    "1212": "7:14",
    "1213": "7:15",
    "1214": "7:16",
    "1215": "7:17",
    "1216": "7:18",
    "1217": "7:19",
    "1218": "8:0",
    "1219": "8:1",
    "1220": "8:2",
    "1221": "8:3",
    "1222": "8:4",
    "1223": "8:5",
    "1224": "8:6",
    "1225": "8:7",
    "1226": "8:8",
    "1227": "8:9",
    "1228": "8:10",
    "1229": "8:11",
    "1230": "8:12",
    "1231": "8:13",
    "1232": "8:14",
    "1233": "8:15",
    "1234": "8:16",
    "1235": "8:17",
    "1236": "8:18",
    "1237": "8:19",
    "1238": "9:0",
    "1239": "9:1",
    "1240": "9:2",
    "1241": "9:3",
    "1242": "9:4",
    "1243": "9:5",
    "1244": "9:6",
    "1245": "9:7",
    "1246": "9:8",
    "1247": "9:9",
    "1248": "9:10",
    "1249": "9:11",
    "1250": "9:12",
    "1251": "9:13",
    "1252": "9:14",
    "1253": "9:15",
    "1254": "9:16",
    "1255": "9:17",
    "1256": "9:18",
    "1257": "9:19",
    "1258": "10:0",
    "1259": "10:1",
    "1260": "10:2",
    "1261": "10:3",
    "1262": "10:4",
    "1263": "10:5",
    "1264": "10:6",
    "1265": "10:7",
    "1266": "10:8",
    "1267": "10:9",
    "1268": "10:10",
    "1269": "10:11",
    "1270": "10:12",
    "1271": "10:13",
    "1272": "10:14",
    "1273": "10:15",
    "1274": "10:16",
    "1275": "10:17",
    "1276": "10:18",
    "1277": "10:19",
    "1278": "11:0",
    "1279": "11:1",
    "1280": "11:2",
    "1281": "11:3",
    "1282": "11:4",
    "1283": "11:5",
    "1284": "11:6",
    "1285": "11:7",
    "1286": "11:8",
    "1287": "11:9",
    "1288": "11:10",
    "1289": "11:11",
    "1290": "11:12",
    "1291": "11:13",
    "1292": "11:14",
    "1293": "11:15",
    "1294": "11:16",
    "1295": "11:17",
    "1296": "11:18",
    "1297": "11:19",
    "1298": "12:0",
    "1299": "12:1",
    "1300": "12:2",
    "1301": "12:3",
    "1302": "12:4",
    "1303": "12:5",
    "1304": "12:6",
    "1305": "12:7",
    "1306": "12:8",
    "1307": "12:9",
    "1308": "12:10",
    "1309": "12:11",
    "1310": "12:12",
    "1311": "12:13",
    "1312": "12:14",
    "1313": "12:15",
    "1314": "12:16",
    "1315": "12:17",
    "1316": "12:18",
    "1317": "12:19",
    "1318": "13:0",
    "1319": "13:1",
    "1320": "13:2",
    "1321": "13:3",
    "1322": "13:4",
    "1323": "13:5",
    "1324": "13:6",
    "1325": "13:7",
    "1326": "13:8",
    "1327": "13:9",
    "1328": "13:10",
    "1329": "13:11",
    "1330": "13:12",
    "1331": "13:13",
    "1332": "13:14",
    "1333": "13:15",
    "1334": "13:16",
    "1335": "13:17",
    "1336": "13:18",
    "1337": "13:19",
    "1338": "14:0",
    "1339": "14:1",
    "1340": "14:2",
    "1341": "14:3",
    "1342": "14:4",
    "1343": "14:5",
    "1344": "14:6",
    "1345": "14:7",
    "1346": "14:8",
    "1347": "14:9",
    "1348": "14:10",
    "1349": "14:11",
    "1350": "14:12",
    "1351": "14:13",
    "1352": "14:14",
    "1353": "14:15",
    "1354": "14:16",
    "1355": "14:17",
    "1356": "14:18",
    "1357": "14:19",
    "1358": "15:0",
    "1359": "15:1",
    "1360": "15:2",
    "1361": "15:3",
    "1362": "15:4",
    "1363": "15:5",
    "1364": "15:6",
    "1365": "15:7",
    "1366": "15:8",
    "1367": "15:9",
    "1368": "15:10",
    "1369": "15:11",
    "1370": "15:12",
    "1371": "15:13",
    "1372": "15:14",
    "1373": "15:15",
    "1374": "15:16",
    "1375": "15:17",
    "1376": "15:18",
    "1377": "15:19",
    "1378": "16:0",
    "1379": "16:1",
    "1380": "16:2",
    "1381": "16:3",
    "1382": "16:4",
    "1383": "16:5",
    "1384": "16:6",
    "1385": "16:7",
    "1386": "16:8",
    "1387": "16:9",
    "1388": "16:10",
    "1389": "16:11",
    "1390": "16:12",
    "1391": "16:13",
    "1392": "16:14",
    "1393": "16:15",
    "1394": "16:16",
    "1395": "16:17",
    "1396": "16:18",
    "1397": "16:19",
    "1398": "17:0",
    "1399": "17:1",
    "1400": "17:2",
    "1401": "17:3",
    "1402": "17:4",
    "1403": "17:5",
    "1404": "17:6",
    "1405": "17:7",
    "1406": "17:8",
    "1407": "17:9",
    "1408": "17:10",
    "1409": "17:11",
    "1410": "17:12",
    "1411": "17:13",
    "1412": "17:14",
    "1413": "17:15",
    "1414": "17:16",
    "1415": "17:17",
    "1416": "17:18",
    "1417": "17:19",
    "1418": "18:0",
    "1419": "18:1",
    "1420": "18:2",
    "1421": "18:3",
    "1422": "18:4",
    "1423": "18:5",
    "1424": "18:6",
    "1425": "18:7",
    "1426": "18:8",
    "1427": "18:9",
    "1428": "18:10",
    "1429": "18:11",
    "1430": "18:12",
    "1431": "18:13",
    "1432": "18:14",
    "1433": "18:15",
    "1434": "18:16",
    "1435": "18:17",
    "1436": "18:18",
    "1437": "18:19",
    "1438": "19:0",
    "1439": "19:1",
    "1440": "19:2",
    "1441": "19:3",
    "1442": "19:4",
    "1443": "19:5",
    "1444": "19:6",
    "1445": "19:7",
    "1446": "19:8",
    "1447": "19:9",
    "1448": "19:10",
    "1449": "19:11",
    "1450": "19:12",
    "1451": "19:13",
    "1452": "19:14",
    "1453": "19:15",
    "1454": "19:16",
    "1455": "19:17",
    "1456": "19:18",
    "1457": "19:19",
    "name": "Doğru skor {!score}",
    "group": "all|score|regular_play"
  },
  "402": {
    "1058": "0:0",
    "1059": "0:1",
    "1060": "0:2",
    "1061": "0:3",
    "1062": "0:4",
    "1063": "0:5",
    "1064": "0:6",
    "1065": "0:7",
    "1066": "0:8",
    "1067": "0:9",
    "1068": "0:10",
    "1069": "0:11",
    "1070": "0:12",
    "1071": "0:13",
    "1072": "0:14",
    "1073": "0:15",
    "1074": "0:16",
    "1075": "0:17",
    "1076": "0:18",
    "1077": "0:19",
    "1078": "1:0",
    "1079": "1:1",
    "1080": "1:2",
    "1081": "1:3",
    "1082": "1:4",
    "1083": "1:5",
    "1084": "1:6",
    "1085": "1:7",
    "1086": "1:8",
    "1087": "1:9",
    "1088": "1:10",
    "1089": "1:11",
    "1090": "1:12",
    "1091": "1:13",
    "1092": "1:14",
    "1093": "1:15",
    "1094": "1:16",
    "1095": "1:17",
    "1096": "1:18",
    "1097": "1:19",
    "1098": "2:0",
    "1099": "2:1",
    "1100": "2:2",
    "1101": "2:3",
    "1102": "2:4",
    "1103": "2:5",
    "1104": "2:6",
    "1105": "2:7",
    "1106": "2:8",
    "1107": "2:9",
    "1108": "2:10",
    "1109": "2:11",
    "1110": "2:12",
    "1111": "2:13",
    "1112": "2:14",
    "1113": "2:15",
    "1114": "2:16",
    "1115": "2:17",
    "1116": "2:18",
    "1117": "2:19",
    "1118": "3:0",
    "1119": "3:1",
    "1120": "3:2",
    "1121": "3:3",
    "1122": "3:4",
    "1123": "3:5",
    "1124": "3:6",
    "1125": "3:7",
    "1126": "3:8",
    "1127": "3:9",
    "1128": "3:10",
    "1129": "3:11",
    "1130": "3:12",
    "1131": "3:13",
    "1132": "3:14",
    "1133": "3:15",
    "1134": "3:16",
    "1135": "3:17",
    "1136": "3:18",
    "1137": "3:19",
    "1138": "4:0",
    "1139": "4:1",
    "1140": "4:2",
    "1141": "4:3",
    "1142": "4:4",
    "1143": "4:5",
    "1144": "4:6",
    "1145": "4:7",
    "1146": "4:8",
    "1147": "4:9",
    "1148": "4:10",
    "1149": "4:11",
    "1150": "4:12",
    "1151": "4:13",
    "1152": "4:14",
    "1153": "4:15",
    "1154": "4:16",
    "1155": "4:17",
    "1156": "4:18",
    "1157": "4:19",
    "1158": "5:0",
    "1159": "5:1",
    "1160": "5:2",
    "1161": "5:3",
    "1162": "5:4",
    "1163": "5:5",
    "1164": "5:6",
    "1165": "5:7",
    "1166": "5:8",
    "1167": "5:9",
    "1168": "5:10",
    "1169": "5:11",
    "1170": "5:12",
    "1171": "5:13",
    "1172": "5:14",
    "1173": "5:15",
    "1174": "5:16",
    "1175": "5:17",
    "1176": "5:18",
    "1177": "5:19",
    "1178": "6:0",
    "1179": "6:1",
    "1180": "6:2",
    "1181": "6:3",
    "1182": "6:4",
    "1183": "6:5",
    "1184": "6:6",
    "1185": "6:7",
    "1186": "6:8",
    "1187": "6:9",
    "1188": "6:10",
    "1189": "6:11",
    "1190": "6:12",
    "1191": "6:13",
    "1192": "6:14",
    "1193": "6:15",
    "1194": "6:16",
    "1195": "6:17",
    "1196": "6:18",
    "1197": "6:19",
    "1198": "7:0",
    "1199": "7:1",
    "1200": "7:2",
    "1201": "7:3",
    "1202": "7:4",
    "1203": "7:5",
    "1204": "7:6",
    "1205": "7:7",
    "1206": "7:8",
    "1207": "7:9",
    "1208": "7:10",
    "1209": "7:11",
    "1210": "7:12",
    "1211": "7:13",
    "1212": "7:14",
    "1213": "7:15",
    "1214": "7:16",
    "1215": "7:17",
    "1216": "7:18",
    "1217": "7:19",
    "1218": "8:0",
    "1219": "8:1",
    "1220": "8:2",
    "1221": "8:3",
    "1222": "8:4",
    "1223": "8:5",
    "1224": "8:6",
    "1225": "8:7",
    "1226": "8:8",
    "1227": "8:9",
    "1228": "8:10",
    "1229": "8:11",
    "1230": "8:12",
    "1231": "8:13",
    "1232": "8:14",
    "1233": "8:15",
    "1234": "8:16",
    "1235": "8:17",
    "1236": "8:18",
    "1237": "8:19",
    "1238": "9:0",
    "1239": "9:1",
    "1240": "9:2",
    "1241": "9:3",
    "1242": "9:4",
    "1243": "9:5",
    "1244": "9:6",
    "1245": "9:7",
    "1246": "9:8",
    "1247": "9:9",
    "1248": "9:10",
    "1249": "9:11",
    "1250": "9:12",
    "1251": "9:13",
    "1252": "9:14",
    "1253": "9:15",
    "1254": "9:16",
    "1255": "9:17",
    "1256": "9:18",
    "1257": "9:19",
    "1258": "10:0",
    "1259": "10:1",
    "1260": "10:2",
    "1261": "10:3",
    "1262": "10:4",
    "1263": "10:5",
    "1264": "10:6",
    "1265": "10:7",
    "1266": "10:8",
    "1267": "10:9",
    "1268": "10:10",
    "1269": "10:11",
    "1270": "10:12",
    "1271": "10:13",
    "1272": "10:14",
    "1273": "10:15",
    "1274": "10:16",
    "1275": "10:17",
    "1276": "10:18",
    "1277": "10:19",
    "1278": "11:0",
    "1279": "11:1",
    "1280": "11:2",
    "1281": "11:3",
    "1282": "11:4",
    "1283": "11:5",
    "1284": "11:6",
    "1285": "11:7",
    "1286": "11:8",
    "1287": "11:9",
    "1288": "11:10",
    "1289": "11:11",
    "1290": "11:12",
    "1291": "11:13",
    "1292": "11:14",
    "1293": "11:15",
    "1294": "11:16",
    "1295": "11:17",
    "1296": "11:18",
    "1297": "11:19",
    "1298": "12:0",
    "1299": "12:1",
    "1300": "12:2",
    "1301": "12:3",
    "1302": "12:4",
    "1303": "12:5",
    "1304": "12:6",
    "1305": "12:7",
    "1306": "12:8",
    "1307": "12:9",
    "1308": "12:10",
    "1309": "12:11",
    "1310": "12:12",
    "1311": "12:13",
    "1312": "12:14",
    "1313": "12:15",
    "1314": "12:16",
    "1315": "12:17",
    "1316": "12:18",
    "1317": "12:19",
    "1318": "13:0",
    "1319": "13:1",
    "1320": "13:2",
    "1321": "13:3",
    "1322": "13:4",
    "1323": "13:5",
    "1324": "13:6",
    "1325": "13:7",
    "1326": "13:8",
    "1327": "13:9",
    "1328": "13:10",
    "1329": "13:11",
    "1330": "13:12",
    "1331": "13:13",
    "1332": "13:14",
    "1333": "13:15",
    "1334": "13:16",
    "1335": "13:17",
    "1336": "13:18",
    "1337": "13:19",
    "1338": "14:0",
    "1339": "14:1",
    "1340": "14:2",
    "1341": "14:3",
    "1342": "14:4",
    "1343": "14:5",
    "1344": "14:6",
    "1345": "14:7",
    "1346": "14:8",
    "1347": "14:9",
    "1348": "14:10",
    "1349": "14:11",
    "1350": "14:12",
    "1351": "14:13",
    "1352": "14:14",
    "1353": "14:15",
    "1354": "14:16",
    "1355": "14:17",
    "1356": "14:18",
    "1357": "14:19",
    "1358": "15:0",
    "1359": "15:1",
    "1360": "15:2",
    "1361": "15:3",
    "1362": "15:4",
    "1363": "15:5",
    "1364": "15:6",
    "1365": "15:7",
    "1366": "15:8",
    "1367": "15:9",
    "1368": "15:10",
    "1369": "15:11",
    "1370": "15:12",
    "1371": "15:13",
    "1372": "15:14",
    "1373": "15:15",
    "1374": "15:16",
    "1375": "15:17",
    "1376": "15:18",
    "1377": "15:19",
    "1378": "16:0",
    "1379": "16:1",
    "1380": "16:2",
    "1381": "16:3",
    "1382": "16:4",
    "1383": "16:5",
    "1384": "16:6",
    "1385": "16:7",
    "1386": "16:8",
    "1387": "16:9",
    "1388": "16:10",
    "1389": "16:11",
    "1390": "16:12",
    "1391": "16:13",
    "1392": "16:14",
    "1393": "16:15",
    "1394": "16:16",
    "1395": "16:17",
    "1396": "16:18",
    "1397": "16:19",
    "1398": "17:0",
    "1399": "17:1",
    "1400": "17:2",
    "1401": "17:3",
    "1402": "17:4",
    "1403": "17:5",
    "1404": "17:6",
    "1405": "17:7",
    "1406": "17:8",
    "1407": "17:9",
    "1408": "17:10",
    "1409": "17:11",
    "1410": "17:12",
    "1411": "17:13",
    "1412": "17:14",
    "1413": "17:15",
    "1414": "17:16",
    "1415": "17:17",
    "1416": "17:18",
    "1417": "17:19",
    "1418": "18:0",
    "1419": "18:1",
    "1420": "18:2",
    "1421": "18:3",
    "1422": "18:4",
    "1423": "18:5",
    "1424": "18:6",
    "1425": "18:7",
    "1426": "18:8",
    "1427": "18:9",
    "1428": "18:10",
    "1429": "18:11",
    "1430": "18:12",
    "1431": "18:13",
    "1432": "18:14",
    "1433": "18:15",
    "1434": "18:16",
    "1435": "18:17",
    "1436": "18:18",
    "1437": "18:19",
    "1438": "19:0",
    "1439": "19:1",
    "1440": "19:2",
    "1441": "19:3",
    "1442": "19:4",
    "1443": "19:5",
    "1444": "19:6",
    "1445": "19:7",
    "1446": "19:8",
    "1447": "19:9",
    "1448": "19:10",
    "1449": "19:11",
    "1450": "19:12",
    "1451": "19:13",
    "1452": "19:14",
    "1453": "19:15",
    "1454": "19:16",
    "1455": "19:17",
    "1456": "19:18",
    "1457": "19:19",
    "name": "1.Y - doğru skor {!score}",
    "group": "all|score|1st_half"
  },
  "404": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!goalnr}. gol (uzatmalar dahil)",
    "group": "all|score|incl_ot"
  },
  "405": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{goalnr}. gol için çekişme (uzatmalar dahil)",
    "group": "all|score|incl_ot"
  },
  "406": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Kazanan (uzatmalar ve penaltılar dahil)",
    "group": "all|score|incl_ot_and_pen"
  },
  "407": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "{!goalnr}. gol (uzatmalar ve penaltılar dahil)",
    "group": "all|score|incl_ot_and_pen"
  },
  "408": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "berabere ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "Handikap {hcp} (uzatmalar ve penaltılar dahil)",
    "group": "all|score|incl_ot_and_pen"
  },
  "409": {
    "630": "{$competitor1} 1 farkla",
    "632": "{$competitor1} 2 farkla",
    "634": "{$competitor1} 3 ve üstü farkla",
    "636": "{$competitor2} 1 farkla",
    "638": "{$competitor2} 2 farkla",
    "640": "{$competitor2} 3 ve üstü farkla",
    "name": "Kazanma farkı (uzatmalar ve penaltılar dahil)",
    "group": "all|score|incl_ot_and_pen"
  },
  "410": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Handikap (uzatmalar ve penaltılar dahil)",
    "group": "all|score|incl_ot_and_pen"
  },
  "411": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "US spread (uzatmalar ve penaltılar dahil)",
    "group": "all|score|incl_ot_and_pen"
  },
  "412": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Toplam gol (uzatmalar ve penaltılar dahil)",
    "group": "all|score|incl_ot_and_pen"
  },
  "413": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "US toplam gol (uzatmalar ve penaltılar dahil)",
    "group": "all|score|incl_ot_and_pen"
  },
  "414": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{$competitor1} toplam gol (uzatmalar ve penaltılar dahil)",
    "group": "all|score|incl_ot_and_pen"
  },
  "415": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{$competitor2} toplam gol (uzatmalar ve penaltılar dahil)",
    "group": "all|score|incl_ot_and_pen"
  },
  "419": {
    "70": "tek",
    "72": "çift",
    "name": "tek/çift (uzatmalar ve penaltılar dahil)",
    "group": "all|score|incl_ot_and_pen"
  },
  "420": {
    "1475": "her ikiside",
    "1476": "sadece {$competitor1}",
    "1477": "sadece {$competitor2}",
    "name": "Hangi takım gol atar (uzatmalar ve penaltılar dahil)",
    "group": "all|score|incl_ot_and_pen"
  },
  "421": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor1} gol yemeden tamamlar (uzatmalar ve penaltılar dahil)",
    "group": "all|score|incl_ot_and_pen"
  },
  "422": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor2} gol yemeden tamamlar (uzatmalar ve penaltılar dahil)",
    "group": "all|score|incl_ot_and_pen"
  },
  "423": {
    "1478": "{$competitor1} gol atar ve {$competitor1} kazanır",
    "1479": "{$competitor1} gol atar ve {$competitor2} kazanır",
    "1480": "{$competitor2} gol atar ve {$competitor1} kazanır",
    "1481": "{$competitor2} gol atar ve {$competitor2} kazanır",
    "name": "{!goalnr}. gol ve kazanan (uzatmalar ve penaltılar dahil)",
    "group": "all|combo|incl_ot_and_pen"
  },
  "424": {
    "794": "{$competitor1} & {total} -ı",
    "796": "{$competitor1} & {total} +ü",
    "798": "X & {total} -ı",
    "800": "X & {total} +ü",
    "802": "{$competitor2} & {total} -ı",
    "804": "{$competitor2} & {total} +ü",
    "name": "1x2 & toplam gol (uzatmalar ve penaltılar  dahil)",
    "group": "all|combo|incl_ot_and_pen"
  },
  "425": {
    "1706": "{$competitor1} & var",
    "1708": "{$competitor1} & yok",
    "1709": "{$competitor2} & var",
    "1710": "{$competitor2} & yok",
    "name": "1x2 & karşılıklı gol var (uzatmalar ve penaltılar dahil)",
    "group": "all|combo|incl_ot_and_pen"
  },
  "426": {
    "1482": "{$competitor1} & {$competitor1}",
    "1483": "X & {$competitor1}",
    "1484": "{$competitor2} & {$competitor1}",
    "1485": "{$competitor1} & {$competitor2}",
    "1486": "X & {$competitor2}",
    "1487": "{$competitor2} & {$competitor2}",
    "name": "{!periodnr}. periyot 1x2 & kazanan (uzatmalar ve penaltılar dahil)",
    "group": "all|combo|incl_ot_and_pen"
  },
  "427": {
    "1488": "1:0",
    "1489": "2:0",
    "1490": "3:0",
    "1491": "4:0",
    "1492": "5:0",
    "1493": "0:1",
    "1494": "2:1",
    "1495": "3:1",
    "1496": "4:1",
    "1497": "5:1",
    "1498": "0:2",
    "1499": "1:2",
    "1500": "3:2",
    "1501": "4:2",
    "1502": "5:2",
    "1503": "0:3",
    "1504": "1:3",
    "1505": "2:3",
    "1506": "4:3",
    "1507": "5:3",
    "1508": "0:4",
    "1509": "1:4",
    "1510": "2:4",
    "1511": "3:4",
    "1512": "5:4",
    "1513": "0:5",
    "1514": "1:5",
    "1515": "2:5",
    "1516": "3:5",
    "1517": "4:5",
    "1518": "diğer",
    "name": "Maç sonucu (uzatmalar ve penaltılar dahil)",
    "group": "all|score|incl_ot_and_pen"
  },
  "429": {
    "1529": "{$competitor1} & {$competitor1}",
    "1530": "X & {$competitor1}",
    "1531": "{$competitor2} & {$competitor1}",
    "1532": "{$competitor1} & beraberlik",
    "1533": "X & beraberlik",
    "1534": "{$competitor2} & beraberlik",
    "1535": "{$competitor1} & {$competitor2}",
    "1536": "X & {$competitor2}",
    "1537": "{$competitor2} & {$competitor2}",
    "name": "{!periodnr}. periyot 1x2 & 1x2",
    "group": "all|regular_play|combo"
  },
  "430": {
    "1538": "0:0",
    "1539": "1:0",
    "1540": "2:0",
    "1541": "3:0",
    "1542": "4:0",
    "1543": "5:0",
    "1544": "6:0",
    "1545": "7:0",
    "1546": "8:0",
    "1547": "0:1",
    "1548": "1:1",
    "1549": "2:1",
    "1550": "3:1",
    "1551": "4:1",
    "1552": "5:1",
    "1553": "6:1",
    "1554": "7:1",
    "1555": "0:2",
    "1556": "1:2",
    "1557": "2:2",
    "1558": "3:2",
    "1559": "4:2",
    "1560": "5:2",
    "1561": "6:2",
    "1562": "0:3",
    "1563": "1:3",
    "1564": "2:3",
    "1565": "3:3",
    "1566": "4:3",
    "1567": "5:3",
    "1568": "0:4",
    "1569": "1:4",
    "1570": "2:4",
    "1571": "3:4",
    "1572": "4:4",
    "1573": "0:5",
    "1574": "1:5",
    "1575": "2:5",
    "1576": "3:5",
    "1577": "0:6",
    "1578": "1:6",
    "1579": "2:6",
    "1580": "0:7",
    "1581": "1:7",
    "1582": "0:8",
    "name": "Maç sonucu {!score}",
    "group": "all|score|regular_play"
  },
  "431": {
    "1584": "0:0",
    "1585": "1:0",
    "1586": "2:0",
    "1587": "3:0",
    "1588": "4:0",
    "1589": "5:0",
    "1590": "0:1",
    "1591": "1:1",
    "1592": "2:1",
    "1593": "3:1",
    "1594": "4:1",
    "1595": "5:1",
    "1596": "0:2",
    "1597": "1:2",
    "1598": "2:2",
    "1599": "3:2",
    "1600": "4:2",
    "1601": "5:2",
    "1602": "0:3",
    "1603": "1:3",
    "1604": "2:3",
    "1605": "3:3",
    "1606": "4:3",
    "1607": "5:3",
    "1608": "0:4",
    "1609": "1:4",
    "1610": "2:4",
    "1611": "3:4",
    "1612": "4:4",
    "1613": "5:4",
    "1614": "0:5",
    "1615": "1:5",
    "1616": "2:5",
    "1617": "3:5",
    "1618": "4:5",
    "1619": "5:5",
    "1620": "diğer",
    "name": "Maç sonucu",
    "group": "all|score|regular_play"
  },
  "432": {
    "1621": "İlk periyot",
    "1622": "İkinci periyot",
    "1623": "Üçüncü periyot",
    "1624": "eşit",
    "name": "En çok sayı olan periyot",
    "group": "all|score|regular_play"
  },
  "433": {
    "1621": "İlk periyot",
    "1622": "İkinci periyot",
    "1623": "Üçüncü periyot",
    "1624": "eşit",
    "name": "{$competitor1}un en çok sayı yapacağı periyot",
    "group": "all|score|regular_play"
  },
  "434": {
    "1621": "İlk periyot",
    "1622": "İkinci periyot",
    "1623": "Üçüncü periyot",
    "1624": "eşit",
    "name": "{$competitor2}un en çok sayı yapacağı periyot",
    "group": "all|score|regular_play"
  },
  "435": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor1} tüm periyotları kazanır",
    "group": "all|score|regular_play"
  },
  "436": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor2} tüm periyotları kazanır",
    "group": "all|score|regular_play"
  },
  "437": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor1} herhangi bir periyodu kazanır",
    "group": "all|score|regular_play"
  },
  "438": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor2} herhangi bir periyodu kazanır",
    "group": "all|score|regular_play"
  },
  "439": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor1} her periyotta sayı yapar",
    "group": "all|score|regular_play"
  },
  "440": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor2} her periyotta sayı yapar",
    "group": "all|score|regular_play"
  },
  "441": {
    "74": "evet",
    "76": "hayır",
    "name": "Bütün periyotlar {total} +ü",
    "group": "all|score|regular_play"
  },
  "442": {
    "74": "evet",
    "76": "hayır",
    "name": "Bütün periyotlar {total} -ı",
    "group": "all|score|regular_play"
  },
  "443": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!periodnr}. periyot - 1x2",
    "group": "all|score|period"
  },
  "444": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "{!periodnr} . periyot - {!goalnr}. gol",
    "group": "all|score|period"
  },
  "445": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "berabere ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "{!periodnr} . periyot - handikap {hcp}",
    "group": "all|score|period"
  },
  "446": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!periodnr} . periyot - toplam",
    "group": "all|score|period"
  },
  "447": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!periodnr} . periyot - {$competitor1} toplam",
    "group": "all|score|period"
  },
  "448": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!periodnr} . periyot - {$competitor2} toplam",
    "group": "all|score|period"
  },
  "452": {
    "74": "evet",
    "76": "hayır",
    "name": "{!periodnr}. periyot - her iki takımda gol atar",
    "group": "all|score|period"
  },
  "453": {
    "784": "Gol olmaz",
    "788": "sadece {$competitor1}",
    "790": "sadece {$competitor2}",
    "792": "her iki takım da",
    "name": "{!periodnr}. periyot - hangi takım gol atar",
    "group": "all|score|period"
  },
  "454": {
    "74": "evet",
    "76": "hayır",
    "name": "{!periodnr}. periyot - {$competitor1} gol yemez",
    "group": "all|score|period"
  },
  "455": {
    "74": "evet",
    "76": "hayır",
    "name": "{!periodnr}. periyot - {$competitor2} gol yemez",
    "group": "all|score|period"
  },
  "456": {
    "1630": "0:0",
    "1631": "1:0",
    "1632": "2:0",
    "1633": "0:1",
    "1634": "1:1",
    "1635": "2:1",
    "1636": "0:2",
    "1637": "1:2",
    "1638": "2:2",
    "1639": "diğer",
    "name": "{!periodnr}. periyot - doğru skor",
    "group": "all|score|period"
  },
  "457": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "{!periodnr}. periyot - son golü kim atar",
    "group": "all|score|period"
  },
  "458": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!periodnr}. periyot - maçın kalanında kim kazanır",
    "group": "all|score|period"
  },
  "459": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!periodnr}. periyot - beraberlikte iade",
    "group": "all|score|period"
  },
  "460": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!periodnr}. periyot - handikap",
    "group": "all|score|period"
  },
  "462": {
    "70": "tek",
    "72": "çift",
    "name": "{!periodnr}. periyot - tek/çift",
    "group": "all|score|period"
  },
  "463": {
    "9": "{$competitor1} veya X",
    "10": "{$competitor1} veya {$competitor2}",
    "11": "X veya {$competitor2}",
    "name": "Uzatmalar - çifte şans",
    "group": "all|score|ot"
  },
  "464": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Uzatmalar - beraberlikte iade",
    "group": "all|score|ot"
  },
  "465": {
    "776": "X",
    "778": "{$competitor2}",
    "name": "Uzatmalar - {$competitor1} kazanırsa iade",
    "group": "all|score|ot"
  },
  "466": {
    "780": "{$competitor1}",
    "782": "X",
    "name": "Uzatmalar - {$competitor2} kazanırsa iade",
    "group": "all|score|ot"
  },
  "467": {
    "1640": "{$competitor1} try ile",
    "1641": "{$competitor1} penaltı ile",
    "1642": "{$competitor1}şutla",
    "1643": "{$competitor2} try ile",
    "1644": "{$competitor2} penaltı ile",
    "1645": "{$competitor2}şutla",
    "name": "{!scorenr}. skor oyun",
    "group": "all|score|regular_play"
  },
  "472": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "1.Y - {pointnr}. sayı çekişmesi",
    "group": "all|score|1st_half"
  },
  "473": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Try 1x2",
    "group": "all|regular_play|tries"
  },
  "474": {
    "9": "{$competitor1} veya X",
    "10": "{$competitor1} veya {$competitor2}",
    "11": "X veya {$competitor2}",
    "name": "Çifte şans dene",
    "group": "all|regular_play|tries"
  },
  "475": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Beraberlikte iade dene",
    "group": "all|regular_play|tries"
  },
  "476": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "berabere ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "{hcp} handikap dene",
    "group": "all|regular_play|tries"
  },
  "477": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Handikap dene",
    "group": "all|regular_play|tries"
  },
  "478": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Toplam try",
    "group": "all|regular_play|tries"
  },
  "479": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{$competitor1} toplam try",
    "group": "all|regular_play|tries"
  },
  "480": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{$competitor2} toplam try",
    "group": "all|regular_play|tries"
  },
  "481": {
    "70": "tek",
    "72": "çift",
    "name": "tek/çift try",
    "group": "all|regular_play|tries"
  },
  "482": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "1.Y - try 1x2",
    "group": "all|1st_half|tries"
  },
  "483": {
    "9": "{$competitor1} veya X",
    "10": "{$competitor1} veya {$competitor2}",
    "11": "X veya {$competitor2}",
    "name": "1.Y - try çifte şans",
    "group": "all|1st_half|tries"
  },
  "484": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "1.Y - try beraberlikte iade",
    "group": "all|1st_half|tries"
  },
  "485": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "berabere ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "1.Y - try handikap{hcp}",
    "group": "all|1st_half|tries"
  },
  "486": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "1.Y - try handikap",
    "group": "all|1st_half|tries"
  },
  "487": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "1.Y - toplam try",
    "group": "all|1st_half|tries"
  },
  "488": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "1.Y - {$competitor1} toplam try",
    "group": "all|1st_half|tries"
  },
  "489": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "1.Y - {$competitor2} toplam try",
    "group": "all|1st_half|tries"
  },
  "490": {
    "70": "tek",
    "72": "çift",
    "name": "1.Y - tek/çift try",
    "group": "all|1st_half|tries"
  },
  "491": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Maçın kalanında hangi takım kazanır",
    "group": "all|score|regular_play"
  },
  "492": {
    "74": "evet",
    "76": "hayır",
    "name": "Karar periyodu olucak mı?",
    "group": "all|score|regular_play"
  },
  "493": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Frame handikapı",
    "group": "all|score|regular_play"
  },
  "494": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Toplam frameler",
    "group": "all|score|regular_play"
  },
  "495": {
    "70": "tek",
    "72": "çift",
    "name": "Tek/çift frame",
    "group": "all|score|regular_play"
  },
  "496": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{framenr}. frame çekişmesi",
    "group": "all|score|regular_play"
  },
  "497": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "{fromframe} den {toframe} a frameler - arka arkaya {frames} frame kazanır",
    "group": "all|score|x_frames"
  },
  "498": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "İlk Franmeden {framenr} e - 1x2",
    "group": "all|score|x_frames"
  },
  "499": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!framenr}. frame - kazanan",
    "group": "all|score|frame"
  },
  "500": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!framenr}. frame - sayı handikapı",
    "group": "all|score|frame"
  },
  "501": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!framenr}. frame - toplam sayılar",
    "group": "all|score|frame"
  },
  "502": {
    "70": "tek",
    "72": "çift",
    "name": "{!framenr}. frame - tek/çift",
    "group": "all|score|frame"
  },
  "503": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!framenr}. frame - {pointnr}. sayı çekişmesi",
    "group": "all|score|frame"
  },
  "504": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!framenr}. frame - en yüksek break yapan oyuncu",
    "group": "all|frame|break"
  },
  "505": {
    "1667": "0-49",
    "1668": "50-99",
    "1669": "100-119",
    "1670": "120-146",
    "1671": "147+",
    "name": "{!framenr}. frame - en yüksek break",
    "group": "all|frame|break"
  },
  "506": {
    "74": "evet",
    "76": "hayır",
    "name": "{!framenr}. frame - 100+ break",
    "group": "all|frame|break"
  },
  "507": {
    "74": "evet",
    "76": "hayır",
    "name": "{!framenr}. frame -  {$competitor1} 100+ break",
    "group": "all|frame|break"
  },
  "508": {
    "74": "evet",
    "76": "hayır",
    "name": "{!framenr}. frame -  {$competitor2} 100+ break",
    "group": "all|frame|break"
  },
  "509": {
    "74": "evet",
    "76": "hayır",
    "name": "{!framenr}. frame -  50+ break",
    "group": "all|frame|break"
  },
  "510": {
    "74": "evet",
    "76": "hayır",
    "name": "{!framenr}. frame -  {$competitor1} 50+ break",
    "group": "all|frame|break"
  },
  "511": {
    "74": "evet",
    "76": "hayır",
    "name": "{!framenr}. frame -  {$competitor2} 50+ break",
    "group": "all|frame|break"
  },
  "512": {
    "74": "evet",
    "76": "hayır",
    "name": "{!framenr}. frame -  fol olur mu",
    "group": "all|score|frame"
  },
  "513": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!framenr}. frame - {!xth}. top pota",
    "group": "all|score|frame"
  },
  "514": {
    "1672": "sarı",
    "1673": "yeşil",
    "1674": "kahverengi",
    "1675": "mavi",
    "1676": "pembe",
    "1677": "siyah",
    "name": "{!framenr} frame - {!xth} colour potted",
    "group": "all|score|frame"
  },
  "515": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!framenr}. frame - oyuncu pota son top",
    "group": "all|score|frame"
  },
  "516": {
    "1678": "kırmızı",
    "1679": "sarı",
    "1680": "yeşil",
    "1681": "kahverengi",
    "1682": "mavi",
    "1683": "pembe",
    "1684": "siyah",
    "1685": "faul",
    "name": "{!framenr}. frame - son sayı alınır",
    "group": "all|score|frame"
  },
  "520": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!gamenr}. oyun - {!pointnr}. puan",
    "group": "all|score|game"
  },
  "525": {
    "74": "evet",
    "76": "hayır",
    "name": "4. set oynanıcak mı",
    "group": "all|score|regular_play"
  },
  "526": {
    "74": "evet",
    "76": "hayır",
    "name": "5. set oynanıcak mı",
    "group": "all|score|regular_play"
  },
  "527": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!setnr}. set - handikap",
    "group": "all|score|set"
  },
  "528": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!setnr}. set - toplam",
    "group": "all|score|set"
  },
  "529": {
    "9": "{$competitor1} veya X",
    "10": "{$competitor1} veya {$competitor2}",
    "11": "X veya {$competitor2}",
    "name": "{!periodnr}. periyod - çifte şans",
    "group": "all|score|period"
  },
  "530": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "1.Y - {!scorenr}. gol",
    "group": "all"
  },
  "538": {
    "1717": "X",
    "name": "Head to head (1x2)",
    "group": "all"
  },
  "540": {
    "1718": "{$competitor1}/X & var",
    "1719": "{$competitor1}/X & yok",
    "1720": "{$competitor1}/{$competitor2} & var",
    "1721": "{$competitor1}/{$competitor2} & yok",
    "1722": "X/{$competitor2} & var",
    "1723": "X/{$competitor2} & yok",
    "name": "Çifte şans (maç) & ilk yarı her iki takımda gol atar",
    "group": "all|regular_play|combo"
  },
  "541": {
    "1718": "{$competitor1}/X & var",
    "1719": "{$competitor1}/X & yok",
    "1720": "{$competitor1}/{$competitor2} & var",
    "1721": "{$competitor1}/{$competitor2} & yok",
    "1722": "X/{$competitor2} & var",
    "1723": "X/{$competitor2} & yok",
    "name": "Çifte şans (maç) & ikinci yarı her iki takımda gol atar",
    "group": "all|regular_play|combo"
  },
  "542": {
    "1718": "{$competitor1}/X & var",
    "1719": "{$competitor1}/X & yok",
    "1720": "{$competitor1}/{$competitor2} & var",
    "1721": "{$competitor1}/{$competitor2} & yok",
    "1722": "X/{$competitor2} & var",
    "1723": "X/{$competitor2} & yok",
    "name": "1.Y - çifte şans & her iki takımda gol atar",
    "group": "all|combo|1st_half"
  },
  "543": {
    "78": "{$competitor1} & var",
    "80": "{$competitor1} & yok",
    "82": "X & var",
    "84": "X & yok",
    "86": "{$competitor2} & var",
    "88": "{$competitor2} & yok",
    "name": "2.Y - 1x2 & her iki takımda gol atar",
    "group": "all|combo|2nd_half"
  },
  "544": {
    "794": "{$competitor1} & {total} -ı",
    "796": "{$competitor1} & {total} +ü",
    "798": "X & {total} -ı",
    "800": "X & {total} +ü",
    "802": "{$competitor2} & {total} -ı",
    "804": "{$competitor2} & {total} +ü",
    "name": "2.Y - 1x2 & toplam gol",
    "group": "all|combo|2nd_half"
  },
  "545": {
    "1718": "{$competitor1}/X & var",
    "1719": "{$competitor1}/X & yok",
    "1720": "{$competitor1}/{$competitor2} & var",
    "1721": "{$competitor1}/{$competitor2} & yok",
    "1722": "X/{$competitor2} & var",
    "1723": "X/{$competitor2} & yok",
    "name": "2.Y - Çifte şans & her iki takımda gol atar",
    "group": "all|combo|2nd_half"
  },
  "546": {
    "1718": "{$competitor1}/X & var",
    "1719": "{$competitor1}/X & yok",
    "1720": "{$competitor1}/{$competitor2} & var",
    "1721": "{$competitor1}/{$competitor2} & yok",
    "1722": "X/{$competitor2} & var",
    "1723": "X/{$competitor2} & yok",
    "name": "Çifte şans & her iki takım da gol atar",
    "group": "all|regular_play|combo"
  },
  "547": {
    "1724": "{$competitor1}/X & {total} -ı",
    "1725": "{$competitor1}/{$competitor2} & {total} -ı",
    "1726": "X/{$competitor2} & {total} -ı",
    "1727": "{$competitor1}/X & {total} +ü",
    "1728": "{$competitor1}/{$competitor2} & {total} +ü",
    "1729": "X/{$competitor2} & {total} +ü",
    "name": "Çifte şans & toplam gol",
    "group": "all|regular_play|combo"
  },
  "548": {
    "1730": "1-2",
    "1731": "1-3",
    "1732": "1-4",
    "1733": "1-5",
    "1734": "1-6",
    "1735": "2-3",
    "1736": "2-4",
    "1737": "2-5",
    "1738": "2-6",
    "1739": "3-4",
    "1740": "3-5",
    "1741": "3-6",
    "1742": "4-5",
    "1743": "4-6",
    "1744": "5-6",
    "1745": "7+",
    "1804": "gol yok",
    "name": "Toplam gol",
    "group": "all|score|regular_play"
  },
  "549": {
    "1746": "1-2",
    "1747": "1-3",
    "1748": "2-3",
    "1749": "4+",
    "1805": "gol yok",
    "name": "{$competitor1} toplam gol",
    "group": "all|score|regular_play"
  },
  "550": {
    "1746": "1-2",
    "1747": "1-3",
    "1748": "2-3",
    "1749": "4+",
    "1805": "gol yok",
    "name": "{$competitor2} toplam gol",
    "group": "all|score|regular_play"
  },
  "551": {
    "1750": "1:0, 2:0 veya 3:0",
    "1751": "0:1, 0:2 veya 0:3",
    "1752": "4:0, 5:0 veya 6:0",
    "1753": "0:4, 0:5 veya 0:6",
    "1754": "2:1, 3:1 veya 4:1",
    "1755": "1:2, 1:3 veya 1:4",
    "1756": "3:2, 4:2, 4:3 veya 5:1",
    "1757": "2:3, 2:4, 3:4 veya 1:5",
    "1758": "diğer ev sahibi galibiyeti",
    "1759": "diğer deplasman galibiyeti",
    "1803": "X",
    "name": "Toplam skor",
    "group": "all|score|regular_play"
  },
  "552": {
    "1746": "1-2",
    "1747": "1-3",
    "1748": "2-3",
    "1749": "4+",
    "1805": "gol yok",
    "name": "1.Y - birden fazla gol",
    "group": "all|score|1st_half"
  },
  "553": {
    "1746": "1-2",
    "1747": "1-3",
    "1748": "2-3",
    "1749": "4+",
    "1805": "gol yok",
    "name": "2.Y - birden fazla gol",
    "group": "all|score|2nd_half"
  },
  "554": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr}. harita - kill beraberlik iade",
    "group": "all|kills|map"
  },
  "555": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!mapnr}. harita - kill handikap",
    "group": "all|kills|map"
  },
  "556": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr}. harita- {!xth} dragon",
    "group": "all|map|structures"
  },
  "557": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr}. harita- {!xth} baron",
    "group": "all|map|structures"
  },
  "558": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr}. harita- {!xth} inhibitor",
    "group": "all|map|structures"
  },
  "563": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "{pointnr}. sayı çekişmesi",
    "group": "all|score|regular_play"
  },
  "565": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "15 dakika - korner 1x2 {from} dan {to} a",
    "group": "all|15_min|corners"
  },
  "566": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "15 dakika - {!cornernr}. korner {from} den {to} a",
    "group": "all|15_min|corners"
  },
  "567": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "15 dakika - korner handikap {from} dan {to} a",
    "group": "all|15_min|corners"
  },
  "568": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "15 dakika - toplam korner sayısı {from} dan {to} a",
    "group": "all|15_min|corners"
  },
  "569": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "15 dakika - {$competitor1} toplam korner sayısı {from} den {to} a",
    "group": "all|15_min|corners"
  },
  "570": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "15 dakika - {$competitor2} toplam korner sayısı {from} den {to} a",
    "group": "all|15_min|corners"
  },
  "571": {
    "70": "tek",
    "72": "çift",
    "name": "15 dakika - tek/çift korner {from} den {to} a",
    "group": "all|15_min|corners"
  },
  "572": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "10 dakika - korner 1x2 {from} den {to} a",
    "group": "all|10_min|corners"
  },
  "573": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "10 dakika - {!cornernr}. korner {from} den {to} a",
    "group": "all|10_min|corners"
  },
  "574": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "10 dakika - korner handikap {from} dan {to} a",
    "group": "all|10_min|corners"
  },
  "575": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "10 dakika - toplam korner sayısı {from} dan {to} a",
    "group": "all|10_min|corners"
  },
  "576": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "10 dakika - {$competitor1} toplam korner sayısı  {from} dan {to} a",
    "group": "all|10_min|corners"
  },
  "577": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "10 dakika - {$competitor2} toplam korner sayısı {from} dan {to} a",
    "group": "all|10_min|corners"
  },
  "578": {
    "70": "tek",
    "72": "çift",
    "name": "10 dakika - tek/çift korner {from} dan {to} a",
    "group": "all|10_min|corners"
  },
  "579": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "5 dakika - korner 1x2 {from} dan {to} a",
    "group": "all|5_min|corners"
  },
  "580": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "5 dakika - {!cornernr}. korner {from} dan {to} a",
    "group": "all|5_min|corners"
  },
  "581": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "5 dakika - korner handikap {from} dan {to} a",
    "group": "all|5_min|corners"
  },
  "582": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "5 takika - toplam korner sayısı {from} dan {to} a",
    "group": "all|5_min|corners"
  },
  "583": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "5 dakika - {$competitor1} toplam korner sayısı {from} dan {to} a",
    "group": "all|5_min|corners"
  },
  "584": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "5 dakika - {$competitor2} toplam korner sayısı {from} dan {to} a",
    "group": "all|5_min|corners"
  },
  "585": {
    "70": "tek",
    "72": "çift",
    "name": "5 dakika - tek/çift korner {from} dan {to} a",
    "group": "all|5_min|corners"
  },
  "586": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "15 dakika - kart 1x2 {from} dan {to} a",
    "group": "all|15_min|bookings"
  },
  "587": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "15 dakika - toplam kart {from} dan {to} a",
    "group": "all|15_min|bookings"
  },
  "588": {
    "74": "evet",
    "76": "hayır",
    "name": "15 dakika - oyundan atılma {from} dan {to} a",
    "group": "all|15_min|bookings"
  },
  "589": {
    "74": "evet",
    "76": "hayır",
    "name": "15 dakika - {$competitor1} oyundan atılma {from} dan {to} a",
    "group": "all|15_min|bookings"
  },
  "590": {
    "74": "evet",
    "76": "hayır",
    "name": "15 dakika - {$competitor2} oyundan atılma {from} dan {to} a",
    "group": "all|15_min|bookings"
  },
  "591": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "10 dakika - kart 1x2 {from} dan {to} a",
    "group": "all|10_min|bookings"
  },
  "592": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "10 dakika - toplam kart {from} dan {to} a",
    "group": "all|10_min|bookings"
  },
  "593": {
    "74": "evet",
    "76": "hayır",
    "name": "10 dakika - oyundan atılma {from} dan {to} a",
    "group": "all|10_min|bookings"
  },
  "594": {
    "74": "evet",
    "76": "hayır",
    "name": "10 dakika - {$competitor1} oyundan atılma {from} dan {to} a",
    "group": "all|10_min|bookings"
  },
  "595": {
    "74": "evet",
    "76": "hayır",
    "name": "10 dakika - {$competitor2} oyundan atılma {from} dan {to} a",
    "group": "all|10_min|bookings"
  },
  "596": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "5 dakika - kart 1x2 {from} dan {to} a",
    "group": "all|5_min|bookings"
  },
  "597": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "5 dakika - toplam kart {from} dan {to} a",
    "group": "all|5_min|bookings"
  },
  "598": {
    "74": "evet",
    "76": "hayır",
    "name": "5 dakika - oyundan atılma {from} dan {to} a",
    "group": "all|5_min|bookings"
  },
  "599": {
    "74": "evet",
    "76": "hayır",
    "name": "5 dakika - {$competitor1} oyundan atılma {from} dan {to} a",
    "group": "all|5_min|bookings"
  },
  "600": {
    "74": "evet",
    "76": "hayır",
    "name": "5 dakika - {$competitor2} oyundan atılma {from} dan {to} a",
    "group": "all|5_min|bookings"
  },
  "601": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "{cornernr}. kornerin çekişmesi",
    "group": "all|regular_play|corners"
  },
  "602": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "1.Y - {cornernr}. kornerin çekişmesi",
    "group": "all|1st_half|corners"
  },
  "603": {
    "1797": "sol yukarı",
    "1798": "sol aşağı",
    "1799": "merkez yukarı",
    "1800": "merkez aşağı",
    "1801": "sağ yukarı",
    "1802": "sağ aşağı",
    "name": "{!goalnr}. gol - vuruş alanı",
    "group": "all|misc"
  },
  "604": {
    "74": "evet",
    "76": "hayır",
    "name": "{!penaltynr}. penaltı vurulu başarılı",
    "group": "all|score|regular_play"
  },
  "605": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr}. devre - toplam",
    "group": "all|score|innings"
  },
  "606": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr}. devre - {$competitor1} toplam",
    "group": "all|score|innings"
  },
  "607": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr}. devre - {$competitor2} toplam",
    "group": "all|score|innings"
  },
  "608": {
    "70": "tek",
    "72": "çift",
    "name": "{!inningnr}. devre - tek/çift",
    "group": "all|score|innings"
  },
  "609": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Çeyrekte en çok sayı yapan takım",
    "group": "all|score|regular_play"
  },
  "610": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "1x2 (uzatmalar dahil)",
    "group": "all|score|incl_ot"
  },
  "611": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!quarternr}. çeyrek - 1x2 (uzatmalar dahil)",
    "group": "all|score|quarter_incl_ot"
  },
  "612": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Beraberlikte iade (uzatmalar dahil)",
    "group": "all|score|incl_ot"
  },
  "613": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!quarternr}. çeyrek - beraberlikte iade (uzatmalar dahil)",
    "group": "all|score|quarter_incl_ot"
  },
  "614": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!quarternr}. çeyrek - handikap (uzatmalar dahil)",
    "group": "all|score|quarter_incl_ot"
  },
  "615": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!quarternr}. çeyrek - toplam (uzatmalar dahil)",
    "group": "all|score|quarter_incl_ot"
  },
  "616": {
    "70": "tek",
    "72": "çift",
    "name": "{$competitor1} tek/çift (uzatmalar dahil)",
    "group": "all|score|incl_ot"
  },
  "617": {
    "70": "tek",
    "72": "çift",
    "name": "{$competitor2} tek/çift (uzatmalar dahil)",
    "group": "all|score|incl_ot"
  },
  "618": {
    "70": "tek",
    "72": "çift",
    "name": "1.Y - {$competitor1} tek/çift",
    "group": "all|score|1st_half"
  },
  "619": {
    "70": "tek",
    "72": "çift",
    "name": "1.Y - {$competitor2} tek/çift",
    "group": "all|score|1st_half"
  },
  "620": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr}. harita - {roundnr}. raound çekişmesi",
    "group": "all|score|map"
  },
  "621": {
    "70": "tek",
    "72": "çift",
    "name": "{!mapnr}. harita - tek/çift raundlar (uzatmalar dahil)",
    "group": "all|score|map_incl_ot"
  },
  "622": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!mapnr}. harita - toplam headshot (uzatmalar dahil)",
    "group": "all|map_incl_ot|kills"
  },
  "623": {
    "74": "evet",
    "76": "hayır",
    "name": "{!mapnr}. harita - ace olucak mı (uzatmalar dahil)",
    "group": "all|map_incl_ot|kills"
  },
  "626": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!mapnr}. map {roundnr}. raund - toplam kill",
    "group": "all|kills|round"
  },
  "627": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!mapnr}. map {roundnr}. raund -  kill handikapı",
    "group": "all|kills|round"
  },
  "628": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr}. map {roundnr}. raund - {!killnr}. kill",
    "group": "all|kills|round"
  },
  "629": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!mapnr}. map {roundnr}. raund - {$competitor1} toplam kill",
    "group": "all|kills|round"
  },
  "630": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!mapnr}. map {roundnr}. raund - {$competitor2} toplam kill",
    "group": "all|kills|round"
  },
  "631": {
    "74": "evet",
    "76": "hayır",
    "name": "{!mapnr}. map {roundnr}. raund - bomba kuruldu",
    "group": "all|round|bomb"
  },
  "632": {
    "74": "evet",
    "76": "hayır",
    "name": "{!mapnr}. map {roundnr}. raund - bomba etkisiz hale getirildi",
    "group": "all|round|bomb"
  },
  "634": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Devrede en yüksek sayıyı yapan takım",
    "group": "all|score|regular_play"
  },
  "638": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr}. devre - {%player} toplam",
    "group": "all"
  },
  "639": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Toplam fours",
    "group": "all"
  },
  "640": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Toplam sixes",
    "group": "all"
  },
  "641": {
    "74": "evet",
    "76": "hayır",
    "name": "{!inningnr}. devre {overnr}. over - {$competitor1} oyundan çıkarılma",
    "group": "all"
  },
  "642": {
    "74": "evet",
    "76": "hayır",
    "name": "{!inningnr}. devre {overnr}. over - {$competitor2} oyundan çıkarılma",
    "group": "all"
  },
  "643": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr}. devre - {%player} toplam fours",
    "group": "all"
  },
  "644": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr}. devre - {%player} toplam sixes",
    "group": "all"
  },
  "645": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!inningnr}. devre {overnr}. over -",
    "group": "all"
  },
  "646": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Görevden almada en yüksek puanı alan takım {!dismissalnr}",
    "group": "all"
  },
  "647": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Maksimum 4 puan vuruşları",
    "group": "all"
  },
  "648": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Maksimum 6 puan vuruşları",
    "group": "all"
  },
  "649": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr}. devre - {$competitor1} toplam oyundan çıkarma",
    "group": "all"
  },
  "650": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr}. devre - {$competitor2} toplam oyundan çıkarma",
    "group": "all"
  },
  "651": {
    "1806": "fielder yakalama",
    "1807": "bowled",
    "1808": "kaleci yakalayışı",
    "1809": "lbw",
    "1810": "run out",
    "1811": "stumped",
    "1812": "diğer",
    "name": "{!inningnr} innings - {%player} oyundan çıkarılma metodu",
    "group": "all"
  },
  "652": {
    "74": "evet",
    "76": "hayır",
    "name": "{!inningnr}. devre {overnr}. over - {$competitor1} boundary",
    "group": "all"
  },
  "653": {
    "74": "evet",
    "76": "hayır",
    "name": "{!inningnr}. devre {overnr}. over - {$competitor2} boundary",
    "group": "all"
  },
  "654": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Toplam dışarı koşular",
    "group": "all"
  },
  "655": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Toplam ekstralar",
    "group": "all"
  },
  "656": {
    "1818": "{%player1}",
    "1819": "X",
    "1820": "{%player2}",
    "name": "{!inningnr}. devre - {!dismissalnr}. partnership 1x2",
    "group": "all"
  },
  "657": {
    "1821": "{%player1}",
    "1822": "{%player2}",
    "name": "{!inningnr}. devre -  {!dismissalnr}. vurucu out",
    "group": "all"
  },
  "658": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr}. devre - {$competitor1} toplam fours",
    "group": "all"
  },
  "659": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr}. devre - {$competitor2} toplam fours",
    "group": "all"
  },
  "660": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr}. devre - {$competitor1} toplam sixes",
    "group": "all"
  },
  "661": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr}. devre - {$competitor2} toplam sixes",
    "group": "all"
  },
  "662": {
    "74": "evet",
    "76": "hayır",
    "name": "{!inningnr}. devre - {%player} oyuncusu sayı {milestone} yapar",
    "group": "all"
  },
  "663": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr}. devre 0 a {overnr} - {$competitor1} toplam oyundan çıkarılma",
    "group": "all"
  },
  "664": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr}. devre 0 a {overnr} - {$competitor2} toplam oyundan çıkarılma",
    "group": "all"
  },
  "665": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!daynr}. gün {sessionnr}. session - topla",
    "group": "all"
  },
  "666": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr}. devre - {$competitor1} toplam ekstralar",
    "group": "all"
  },
  "667": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr}. devre - {$competitor2} toplam ekstralar",
    "group": "all"
  },
  "668": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr}. devre - {$competitor1} toplam dışarı koşu",
    "group": "all"
  },
  "669": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr}. devre - {$competitor2} toplam dışarı koşu",
    "group": "all"
  },
  "670": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr}. devre - {$competitor1} toplamda en yüksek sayı yapan",
    "group": "all"
  },
  "671": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr}. devre - {$competitor2} toplamda en yüksek sayı yapan",
    "group": "all"
  },
  "680": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Maksimum ekstralar",
    "group": "all"
  },
  "681": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "En çok dışarı koşu",
    "group": "all"
  },
  "682": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "En yüksek puanı yapan",
    "group": "all"
  },
  "686": {
    "1818": "{%player1}",
    "1819": "X",
    "1820": "{%player2}",
    "name": "Vurucu head2head (1x2)",
    "group": "all"
  },
  "687": {
    "1818": "{%player1}",
    "1819": "X",
    "1820": "{%player2}",
    "name": "Atıcı head2head (1x2)",
    "group": "all"
  },
  "688": {
    "1818": "{%player1}",
    "1819": "X",
    "1820": "{%player2}",
    "name": "All-rounder head2head (1x2)",
    "group": "all"
  },
  "689": {
    "1818": "{%player1}",
    "1819": "X",
    "1820": "{%player2}",
    "name": "Kaleci head2head (1x2)",
    "group": "all"
  },
  "690": {
    "70": "tek",
    "72": "çift",
    "name": "{!inningnr}. devre - {$competitor1} tek çift",
    "group": "all"
  },
  "691": {
    "70": "tek",
    "72": "çift",
    "name": "{!inningnr}. devre - {$competitor2} tek çift",
    "group": "all"
  },
  "692": {
    "74": "evet",
    "76": "hayır",
    "name": "{!inningnr}. devre - {$competitor1} boundary ile bitirir",
    "group": "all"
  },
  "693": {
    "74": "evet",
    "76": "hayır",
    "name": "{!inningnr}. devre - {$competitor2} boundary ile bitirir",
    "group": "all"
  },
  "694": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Yazı-turayı hangi takım kazanır",
    "group": "all"
  },
  "695": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Toplam duck",
    "group": "all"
  },
  "696": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Toplam wide",
    "group": "all"
  },
  "697": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Toplam çıkarılma",
    "group": "all"
  },
  "698": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "En iyi vurucunun olduğu takım",
    "group": "all"
  },
  "699": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "En iyi atıcının olduğu takım",
    "group": "all"
  },
  "700": {
    "74": "evet",
    "76": "hayır",
    "name": "{!inningnr}. devre - herhangi bir oyuncu sayı {milestone} yapar",
    "group": "all"
  },
  "701": {
    "74": "evet",
    "76": "hayır",
    "name": "Herhangi bir oyuncu sayı {milestone} yapar",
    "group": "all"
  },
  "702": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "En iyi vurucu toplam",
    "group": "all"
  },
  "703": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Toplam rabbit",
    "group": "all"
  },
  "704": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr} innings - {$competitor1} Üst/Alt wides bowled",
    "group": "all"
  },
  "705": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr} innings - {$competitor2} Üst/Alt wides bowled",
    "group": "all"
  },
  "706": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr}. devre - {$competitor1} toplam duck",
    "group": "all"
  },
  "707": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr}. devre - {$competitor2} toplam duck",
    "group": "all"
  },
  "708": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr} devre - {%player} toplam çıkarılma",
    "group": "all"
  },
  "709": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{%player} toplam oyuncu performansı",
    "group": "all"
  },
  "710": {
    "1813": "{$competitor1}",
    "1814": "her ikiside değil",
    "1815": "{$competitor2}",
    "name": "Yazı-turayı ve maçı hangi takım kazanır",
    "group": "all"
  },
  "711": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!inningnr}. devre - 1x2",
    "group": "all"
  },
  "712": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "En çok kaleci yakalayışı",
    "group": "all"
  },
  "713": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "En çok yakalama",
    "group": "all"
  },
  "714": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "En çok stumpings",
    "group": "all"
  },
  "717": {
    "1816": "{%player1} ({+hcp})",
    "1817": "{%player2} ({-hcp})",
    "name": "Vurucu head2head (handikap)",
    "group": "all"
  },
  "718": {
    "1806": "fielder yakalama",
    "1807": "bowled",
    "1808": "kaleci yakalayışı",
    "1809": "lbw",
    "1810": "run out",
    "1811": "stumped",
    "1812": "diğer",
    "name": "{!inningnr}. devre - {!dismissalnr}. çıkarılma metodu (uzatılmış)",
    "group": "all"
  },
  "723": {
    "74": "evet",
    "76": "hayır",
    "name": "Hücum olucak mı",
    "group": "all|regular_play|kills"
  },
  "724": {
    "74": "evet",
    "76": "hayır",
    "name": "Ultra kill olucak mı",
    "group": "all|regular_play|kills"
  },
  "725": {
    "1831": "00:00 - {(minute-1)}:59",
    "1832": "{minute}:00+",
    "name": "{!mapnr}. harita - süre",
    "group": "all|map|progress"
  },
  "726": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!mapnr}. harita - toplam kill",
    "group": "all|kills|map"
  },
  "727": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!mapnr}. harita - kalkan",
    "group": "all|map|structures"
  },
  "728": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!mapnr}. harita - toplam kule",
    "group": "all|map|structures"
  },
  "729": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!mapnr}. harita - kalkan handikapı",
    "group": "all|map|structures"
  },
  "730": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!mapnr}. harita - kule handikapı",
    "group": "all|map|structures"
  },
  "731": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr}. harita - {xth}. kill çekşmesi",
    "group": "all|kills|map"
  },
  "732": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr}. harita - {xth}. net worth çekişmesi",
    "group": "all|map|progress"
  },
  "733": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr}. harita - {xth}. level çekişmesi",
    "group": "all|map|progress"
  },
  "734": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!mapnr}. harita 10 dakika - toplam kill {from} den {to} e",
    "group": "all|10_min|kills"
  },
  "736": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr}. harita ilk yarı - kazanan",
    "group": "all|score|map_1st_half"
  },
  "737": {
    "961": "0",
    "962": "1",
    "963": "2",
    "964": "3",
    "965": "4",
    "966": "5+",
    "name": "Maksimum ardarda koşu",
    "group": "all|score|regular_play"
  },
  "738": {
    "1823": "9. devrenin sonunda",
    "1824": "9. devrenin başında",
    "1825": "uzatma devresinde",
    "name": "Maç ne zaman belli olacak",
    "group": "all|score|regular_play"
  },
  "739": {
    "1826": "{!inningnr} devre",
    "1828": "{!(inningnr+1)} devre",
    "1829": "{!(inningnr+2)} devre",
    "1830": "diğer devre veya koşu yok",
    "name": "{!runnr}. koşu ne xaman olur (uzatmalar dahil)",
    "group": "all|score|incl_ei"
  },
  "740": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Sayı olmayan devre sayısı",
    "group": "all|score|regular_play"
  },
  "741": {
    "74": "evet",
    "76": "hayır",
    "name": "İki takımda {total} +ü (uzatmalar dahil)",
    "group": "all|score|incl_ei"
  },
  "742": {
    "1529": "{$competitor1} & {$competitor1}",
    "1530": "X & {$competitor1}",
    "1531": "{$competitor2} & {$competitor1}",
    "1532": "{$competitor1} & beraberlik",
    "1533": "X & beraberlik",
    "1534": "{$competitor2} & beraberlik",
    "1535": "{$competitor1} & {$competitor2}",
    "1536": "X & {$competitor2}",
    "1537": "{$competitor2} & {$competitor2}",
    "name": "İlk {innings} devre - 1x2 & 1x2 (uzatmalar dahil)",
    "group": "all|combo|incl_ei"
  },
  "743": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Devre {from} den {to} e - 1x2",
    "group": "all|score|3_innings"
  },
  "744": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Devre {from} den {to} e - handikap",
    "group": "all|score|3_innings"
  },
  "745": {
    "70": "tek",
    "72": "çift",
    "name": "Devre {from} den {to} e - tek7çift",
    "group": "all|score|3_innings"
  },
  "746": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!inningnr}. devre - handikap",
    "group": "all|score|inning"
  },
  "747": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr}. devre - {$competitor1} toplam",
    "group": "all|score|inning"
  },
  "748": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr}. devre - {$competitor2} toplam",
    "group": "all|score|inning"
  },
  "749": {
    "74": "evet",
    "76": "hayır",
    "name": "{!inningnr}. devre - {$competitor1} sayı yapar",
    "group": "all|score|inning"
  },
  "750": {
    "74": "evet",
    "76": "hayır",
    "name": "{!inningnr}. devre - {$competitor2} sayı yapar",
    "group": "all|score|inning"
  },
  "751": {
    "74": "evet",
    "76": "hayır",
    "name": "{!inningnr}. devre - her iki takımda sayı yapar",
    "group": "all|score|inning"
  },
  "752": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr}. harita - {!xth}. tapınak",
    "group": "all|map|structures"
  },
  "753": {
    "9": "{$competitor1} veya X",
    "10": "{$competitor1} veya {$competitor2}",
    "11": "X veya {$competitor2}",
    "name": "{!quarternr} çeyrek - çifte şans",
    "group": "all|score|quarter"
  },
  "754": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!quarternr} çeyrek - maçın kalanını hangi takım kazanır",
    "group": "all|score|quarter"
  },
  "756": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!quarternr} çeyrek - {$competitor1} toplam",
    "group": "all|score|quarter"
  },
  "757": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!quarternr} çeyrek - {$competitor2} toplam",
    "group": "all|score|quarter"
  },
  "797": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{$event} maç günü {matchday} - ev sahibi toplam",
    "group": "all|matchday"
  },
  "798": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{$event} maç günü {matchday} - deplasman takımı toplam",
    "group": "all|matchday"
  },
  "799": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{$event} maç günü {matchday} - toplam",
    "group": "all|matchday"
  },
  "800": {
    "1833": "ev sahibi takımı",
    "1834": "X",
    "1835": "deplasman takımı",
    "name": "{$event} maç günü {matchday} - en çok sayıda gol ev sahibi veya deplasman takımları",
    "group": "all|matchday"
  },
  "801": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{$event} maç günü {matchday} - toplam ev sahibi takım kazanma sayısı",
    "group": "all|matchday"
  },
  "802": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{$event} maç günü {matchday} - toplam beraberlik sayısı",
    "group": "all|matchday"
  },
  "803": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{$event} maç günü {matchday} - toplam deplasman takımı kazanma sayısı",
    "group": "all|matchday"
  },
  "815": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} - harita - asist draw no bet",
    "group": "all"
  },
  "816": {
    "1806": "fielder yakalama",
    "1807": "bowled",
    "1808": "kaleci yakalayışı",
    "1809": "lbw",
    "1810": "run out",
    "1811": "stumped",
    "1812": "diğer",
    "name": "{!inningnr} devre - {$competitor1} - {!dismissalnr} çıkarılma method (uzatılmış)",
    "group": "all"
  },
  "817": {
    "1806": "fielder yakalama",
    "1807": "bowled",
    "1808": "kaleci yakalayışı",
    "1809": "lbw",
    "1810": "run out",
    "1811": "stumped",
    "1812": "diğer",
    "name": "{!inningnr} devre - {$competitor2} - {!dismissalnr} çıkarılma method (uzatılmış)",
    "group": "all"
  },
  "818": {
    "1836": "{$competitor1}/{$competitor1} & {total} -ı",
    "1837": "{$competitor1}/X & {total} -ı",
    "1838": "{$competitor1}/{$competitor2} & {total} -ı",
    "1839": "X/{$competitor1} & {total} -ı",
    "1840": "X/X & {total} -ı",
    "1841": "X/{$competitor2} & {total} -ı",
    "1842": "{$competitor2}/{$competitor1} & {total} -ı",
    "1843": "{$competitor2}/X & {total} -ı",
    "1844": "{$competitor2}/{$competitor2} & {total} -ı",
    "1845": "{$competitor1}/{$competitor1} & {total} +ü",
    "1846": "{$competitor1}/X & {total} +ü",
    "1847": "{$competitor1}/{$competitor2} & {total} +ü",
    "1848": "X/{$competitor1} & {total} +ü",
    "1849": "X/X & {total} +ü",
    "1850": "X/{$competitor2} & {total} +ü",
    "1851": "{$competitor2}/{$competitor1} & {total} +ü",
    "1852": "{$competitor2}/X & {total} +ü",
    "1853": "{$competitor2}/{$competitor2} & {total} +ü",
    "name": "İlkyarı/maç sonucu & toplam",
    "group": "all|regular_play|combo"
  },
  "819": {
    "1836": "{$competitor1}/{$competitor1} & {total} -ı",
    "1837": "{$competitor1}/X & {total} -ı",
    "1838": "{$competitor1}/{$competitor2} & {total} -ı",
    "1839": "X/{$competitor1} & {total} -ı",
    "1840": "X/X & {total} -ı",
    "1841": "X/{$competitor2} & {total} -ı",
    "1842": "{$competitor2}/{$competitor1} & {total} -ı",
    "1843": "{$competitor2}/X & {total} -ı",
    "1844": "{$competitor2}/{$competitor2} & {total} -ı",
    "1845": "{$competitor1}/{$competitor1} & {total} +ü",
    "1846": "{$competitor1}/X & {total} +ü",
    "1847": "{$competitor1}/{$competitor2} & {total} +ü",
    "1848": "X/{$competitor1} & {total} +ü",
    "1849": "X/X & {total} +ü",
    "1850": "X/{$competitor2} & {total} +ü",
    "1851": "{$competitor2}/{$competitor1} & {total} +ü",
    "1852": "{$competitor2}/X & {total} +ü",
    "1853": "{$competitor2}/{$competitor2} & {total} +ü",
    "name": "İlkyarı/maç sonucu & birinci devre toplam",
    "group": "all|regular_play|combo"
  },
  "820": {
    "1854": "X/X & 0",
    "1855": "{$competitor1}/{$competitor1} & 1",
    "1856": "X/{$competitor1} & 1",
    "1857": "X/{$competitor2} & 1",
    "1858": "{$competitor2}/{$competitor2} & 1",
    "1859": "{$competitor1}/{$competitor1} & 2",
    "1860": "{$competitor1}/X & 2",
    "1861": "X/{$competitor1} & 2",
    "1862": "X/X & 2",
    "1863": "X/{$competitor2} & 2",
    "1864": "{$competitor2}/X & 2",
    "1865": "{$competitor2}/{$competitor2} & 2",
    "1866": "{$competitor1}/{$competitor1} & 3",
    "1867": "{$competitor1}/{$competitor2} & 3",
    "1868": "X/{$competitor1} & 3",
    "1869": "X/{$competitor2} & 3",
    "1870": "{$competitor2}/{$competitor1} & 3",
    "1871": "{$competitor2}/{$competitor2} & 3",
    "1872": "{$competitor1}/{$competitor1} & 4",
    "1873": "{$competitor1}/X & 4",
    "1874": "{$competitor1}/{$competitor2} & 4",
    "1875": "X/{$competitor1} & 4",
    "1876": "X/X & 4",
    "1877": "X/{$competitor2} & 4",
    "1878": "{$competitor2}/{$competitor1} & 4",
    "1879": "{$competitor2}/X & 4",
    "1880": "{$competitor2}/{$competitor2} & 4",
    "1881": "{$competitor1}/{$competitor1} & 5+",
    "1882": "{$competitor1}/X & 5+",
    "1883": "{$competitor1}/{$competitor2} & 5+",
    "1884": "X/{$competitor1} & 5+",
    "1885": "X/X & 5+",
    "1886": "X/{$competitor2} & 5+",
    "1887": "{$competitor2}/{$competitor1} & 5+",
    "1888": "{$competitor2}/X & 5+",
    "1889": "{$competitor2}/{$competitor2} & 5+",
    "name": "İlkyarı/maç sonucu & skor sayısı",
    "group": "all|regular_play|combo"
  },
  "821": {
    "70": "tek",
    "72": "çift",
    "name": "Draw toplam tek/çift",
    "group": "all"
  },
  "822": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Draw toplam, toplam sayı",
    "group": "all"
  },
  "824": {
    "70": "tek",
    "72": "çift",
    "name": "Bonus ball tek/çift",
    "group": "all"
  },
  "825": {
    "70": "tek",
    "72": "çift",
    "name": "Bonus ball toplam tek/çift",
    "group": "all"
  },
  "826": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Bonus ball toplam",
    "group": "all"
  },
  "827": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Bonus ball toplam, toplam sayı",
    "group": "all"
  },
  "828": {
    "74": "evet",
    "76": "hayır",
    "name": "Bonus ball tek hane",
    "group": "all"
  },
  "829": {
    "74": "evet",
    "76": "hayır",
    "name": "Bonus ball hiç bir regular balla eşit değil",
    "group": "all"
  },
  "831": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Draw toplam , toplam sayı (bonus ball dahil)",
    "group": "all"
  },
  "835": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{$competitor1} windex",
    "group": "all"
  },
  "836": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{$competitor2} windex",
    "group": "all"
  },
  "837": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{$competitor1}/{$competitor2} supremacy",
    "group": "all"
  },
  "838": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{$competitor2}/{$competitor1} supremacy",
    "group": "all"
  },
  "839": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings - {$competitor1} Üst/Alt spread",
    "group": "all"
  },
  "840": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings - {$competitor2} Üst/Alt spread",
    "group": "all"
  },
  "841": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings - {$competitor1} Üst/Alt spread at {!dismissalnr} dismissal",
    "group": "all"
  },
  "842": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings - {$competitor2} Üst/Alt spread at {!dismissalnr} dismissal",
    "group": "all"
  },
  "843": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings - {%player} Üst/Alt spread",
    "group": "all"
  },
  "844": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings overs 0 to {overnr} - {$competitor1} Üst/Alt spread",
    "group": "all"
  },
  "845": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings overs 0 to {overnr} - {$competitor2} Üst/Alt spread",
    "group": "all"
  },
  "846": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings over {overnr} - {$competitor1} Üst/Alt spread",
    "group": "all"
  },
  "847": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings over {overnr} - {$competitor2} Üst/Alt spread",
    "group": "all"
  },
  "850": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor1} sadece 1 set kazanır",
    "group": "all|score|regular_play"
  },
  "851": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor2} sadece 1 set kazanır",
    "group": "all|score|regular_play"
  },
  "852": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor1} sadece 2 set kazanır",
    "group": "all|score|regular_play"
  },
  "853": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor2} sadece 2 set kazanır",
    "group": "all|score|regular_play"
  },
  "854": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor1} ya da {total} +",
    "group": "all|regular_play|combo"
  },
  "855": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor1} ya da {total} -",
    "group": "all|regular_play|combo"
  },
  "856": {
    "74": "evet",
    "76": "hayır",
    "name": "Berabere ya da {total} +",
    "group": "all|regular_play|combo"
  },
  "857": {
    "74": "evet",
    "76": "hayır",
    "name": "Berabere ya da {total} -",
    "group": "all|regular_play|combo"
  },
  "858": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor2} ya da {total} +",
    "group": "all|regular_play|combo"
  },
  "859": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor2} ya da {total} -",
    "group": "all|regular_play|combo"
  },
  "860": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor1} ya da iki takımda gol atar",
    "group": "all|regular_play|combo"
  },
  "861": {
    "74": "evet",
    "76": "hayır",
    "name": "Berabere ya da her iki takımda gol atar",
    "group": "all|regular_play|combo"
  },
  "862": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor2} ya da iki takımda gol atar",
    "group": "all|regular_play|combo"
  },
  "863": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor1} ya da gol yemez",
    "group": "all|regular_play|combo"
  },
  "864": {
    "74": "evet",
    "76": "hayır",
    "name": "Beraber ya da gol yemez",
    "group": "all|regular_play|combo"
  },
  "865": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor2} ya da gol yemez",
    "group": "all|regular_play|combo"
  },
  "870": {
    "1893": "others",
    "name": "Exacta",
    "group": "all"
  },
  "871": {
    "1893": "others",
    "name": "Quinella",
    "group": "all"
  },
  "872": {
    "1893": "others",
    "name": "Trifecta",
    "group": "all"
  },
  "873": {
    "1893": "others",
    "name": "Trio",
    "group": "all"
  },
  "875": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr} devre - {$competitor1} toplamda {!dismissalnr} dismissal",
    "group": "all"
  },
  "876": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr} devre - {$competitor2} toplamda {!dismissalnr} dismissal",
    "group": "all"
  },
  "877": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr} devre - {$competitor1} toplam",
    "group": "all"
  },
  "878": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr} devre - {$competitor2} toplam",
    "group": "all"
  },
  "879": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor2} kazanan",
    "group": "all|score|regular_play"
  },
  "880": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor1} kazanan",
    "group": "all|score|regular_play"
  },
  "881": {
    "74": "evet",
    "76": "hayır",
    "name": "Kazanan herhangi bir takım",
    "group": "all|score|regular_play"
  },
  "882": {
    "74": "evet",
    "76": "hayır",
    "name": "{%player} to score (incl. overtime)",
    "group": "all|scorers|incl_ot"
  },
  "883": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "1 dakika - {from}dan {to}a kadar toplam gol",
    "group": "all|score|rapid_market"
  },
  "884": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "1 dakika - toplam korner sayısı {from}dan {to}a kadar",
    "group": "all|corners|rapid_market"
  },
  "885": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "1 dakika - toplam rezervasyon {from}dan {to}a kadar",
    "group": "all|bookings|rapid_market"
  },
  "886": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "1 dakika - toplam ofsaytlar {from}dan {to}a kadar",
    "group": "all|rapid_market|offsides"
  },
  "887": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "1 dakika - toplam penaltı kararı {from}dan {to}a kadar",
    "group": "all|rapid_market|penalties"
  },
  "888": {
    "1894": "{%player} & {$competitor1}",
    "1895": "{%player} & berabere",
    "1896": "{%player} & {$competitor2}",
    "1897": "diğer",
    "name": "Her zaman golü atan & 1x2",
    "group": "all|regular_play|combo"
  },
  "889": {
    "1898": "{%player} & 1:0",
    "1899": "{%player} & 2:0",
    "1900": "{%player} & 3:0",
    "1901": "{%player} & 4:0",
    "1902": "{%player} & 2:1",
    "1903": "{%player} & 3:1",
    "1904": "{%player} & 4:1",
    "1905": "{%player} & 3:2",
    "1906": "{%player} & 4:2",
    "1907": "{%player} & 4:3",
    "1908": "{%player} & 0:1",
    "1909": "{%player} & 0:2",
    "1910": "{%player} & 0:3",
    "1911": "{%player} & 0:4",
    "1912": "{%player} & 1:2",
    "1913": "{%player} & 1:3",
    "1914": "{%player} & 1:4",
    "1915": "{%player} & 2:3",
    "1916": "{%player} & 2:4",
    "1917": "{%player} & 3:4",
    "1918": "{%player} & 1:1",
    "1919": "{%player} & 2:2",
    "1920": "{%player} & 3:3",
    "1921": "{%player} & 4:4",
    "1922": "diğer",
    "name": "Her zaman golü atan & doğru skor",
    "group": "all|regular_play|combo"
  },
  "890": {
    "1898": "{%player} & 1:0",
    "1899": "{%player} & 2:0",
    "1900": "{%player} & 3:0",
    "1901": "{%player} & 4:0",
    "1902": "{%player} & 2:1",
    "1903": "{%player} & 3:1",
    "1904": "{%player} & 4:1",
    "1905": "{%player} & 3:2",
    "1906": "{%player} & 4:2",
    "1907": "{%player} & 4:3",
    "1908": "{%player} & 0:1",
    "1909": "{%player} & 0:2",
    "1910": "{%player} & 0:3",
    "1911": "{%player} & 0:4",
    "1912": "{%player} & 1:2",
    "1913": "{%player} & 1:3",
    "1914": "{%player} & 1:4",
    "1915": "{%player} & 2:3",
    "1916": "{%player} & 2:4",
    "1917": "{%player} & 3:4",
    "1918": "{%player} & 1:1",
    "1919": "{%player} & 2:2",
    "1920": "{%player} & 3:3",
    "1921": "{%player} & 4:4",
    "1922": "diğer",
    "name": "{!goalnr} golü atan & doğru skor",
    "group": "all|regular_play|combo"
  },
  "891": {
    "1894": "{%player} & {$competitor1}",
    "1895": "{%player} & berabere",
    "1896": "{%player} & {$competitor2}",
    "1897": "diğer",
    "name": "{!goalnr} golü atan & 1x2",
    "group": "all|regular_play|combo"
  },
  "894": {
    "1923": "7:0",
    "1924": "7:1",
    "1925": "7:2",
    "1926": "7:3",
    "1927": "7:4",
    "1928": "7:5",
    "1929": "other {$competitor1} win",
    "1930": "0:7",
    "1931": "1:7",
    "1932": "2:7",
    "1933": "3:7",
    "1934": "4:7",
    "1935": "5:7",
    "1936": "other {$competitor2} win",
    "name": "{!setnr} set tiebreak - doğru skor",
    "group": "all|score|tiebreak"
  },
  "895": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!setnr} set tiebreak - Üst/Alt points",
    "group": "all|score|tiebreak"
  },
  "896": {
    "1937": "shot",
    "1938": "header",
    "1939": "own goal",
    "1940": "penalty",
    "1941": "free kick",
    "1942": "none",
    "name": "{!scorenr} scoring type",
    "group": "all|score|regular_play"
  },
  "897": {
    "462": "0:0",
    "464": "1:1",
    "466": "2:2",
    "468": "1:0",
    "470": "2:0",
    "472": "2:1",
    "474": "0:1",
    "476": "0:2",
    "478": "1:2",
    "480": "diğer",
    "name": "Overtime - doğru skor",
    "group": "all|score|ot"
  },
  "902": {
    "1640": "{$competitor1} try ile",
    "1641": "{$competitor1} penaltı ile",
    "1642": "{$competitor1}şutla",
    "1643": "{$competitor2} try ile",
    "1644": "{$competitor2} penaltı ile",
    "1645": "{$competitor2}şutla",
    "name": "Next scoring play",
    "group": "all|score|regular_play"
  },
  "903": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "Next score (incl. overtime)",
    "group": "all|score|incl_ot"
  },
  "904": {
    "1945": "touchdown",
    "1946": "field goal",
    "1947": "safety",
    "1948": "none",
    "name": "Next scoring type (incl. overtime)",
    "group": "all|score|incl_ot"
  },
  "905": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "1st half - next score",
    "group": "all|score|1st_half"
  },
  "911": {
    "74": "evet",
    "76": "hayır",
    "name": "Will the fight go the distance",
    "group": "all"
  },
  "914": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{%player} Üst/Alt passing yards (incl. overtime)",
    "group": "all"
  },
  "915": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{%player} Üst/Alt pass completions (incl. overtime)",
    "group": "all"
  },
  "916": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{%player} Üst/Alt passing touchdowns (incl. overtime)",
    "group": "all"
  },
  "917": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{%player} Üst/Alt carries (incl. overtime)",
    "group": "all"
  },
  "918": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{%player} Üst/Alt rushing yards (incl. overtime)",
    "group": "all"
  },
  "919": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{%player} Üst/Alt receiving yards (incl. overtime)",
    "group": "all"
  },
  "920": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{%player} Üst/Alt receptions (incl. overtime)",
    "group": "all"
  },
  "921": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{%player} Üst/Alt points (incl. overtime)",
    "group": "all|score|incl_ot|player_props"
  },
  "922": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{%player} Üst/Alt assists (incl. overtime)",
    "group": "all|incl_ot|player_props|assist"
  },
  "923": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{%player} Üst/Alt rebounds (incl. overtime)",
    "group": "all|incl_ot|player_props|rebound"
  },
  "924": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{%player} Üst/Alt 3-point field goals (incl. overtime)",
    "group": "all|score|incl_ot|player_props"
  },
  "925": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{%player} Üst/Alt pitcher strikeouts (incl. extra innings)",
    "group": "all|incl_ei"
  },
  "926": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{%player} Üst/Alt bases (incl. extra innings)",
    "group": "all|incl_ei"
  },
  "927": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{%player} Üst/Alt batter runs + runs batted in (incl. extra innings)",
    "group": "all|incl_ei"
  },
  "928": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{%player} Üst/Alt earned runs (incl. extra innings)",
    "group": "all|incl_ei"
  },
  "929": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{%player} Üst/Alt saves (incl. overtime)",
    "group": "all"
  },
  "931": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Üst/Alt touchdowns (incl. overtime)",
    "group": "all|incl_ot"
  },
  "932": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Üst/Alt field goals made (incl. overtime)",
    "group": "all|incl_ot"
  },
  "933": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Üst/Alt turnovers (incl. overtime)",
    "group": "all"
  },
  "934": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Üst/Alt sacks (incl. overtime)",
    "group": "all"
  },
  "940": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!fieldgoalnr} field goal made (incl. overtime)",
    "group": "all"
  },
  "956": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!timeoutnr} timeout",
    "group": "all"
  },
  "959": {
    "1961": "field goal attempt",
    "1962": "offensive touchdown",
    "1963": "punt",
    "1964": "turnover",
    "1965": "safety",
    "name": "{!drivenr} drive - result",
    "group": "all"
  },
  "960": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!quarternr} quarter - last point",
    "group": "all"
  },
  "961": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!freethrownr} free throw scored",
    "group": "all"
  },
  "962": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{$competitor1} Üst/Alt maximum consecutive points",
    "group": "all"
  },
  "963": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{$competitor2} Üst/Alt maximum consecutive points",
    "group": "all"
  },
  "964": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Any team Üst/Alt maximum consecutive points",
    "group": "all"
  },
  "965": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor1} to lead by {points}",
    "group": "all"
  },
  "966": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor2} to lead by {points}",
    "group": "all"
  },
  "967": {
    "74": "evet",
    "76": "hayır",
    "name": "Any team to lead by {points}",
    "group": "all"
  },
  "970": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "Üst/Alt sixes spread",
    "group": "all"
  },
  "971": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "Multi sixes spread",
    "group": "all"
  },
  "972": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{$competitor1} 10/3 sixes head2head spread",
    "group": "all"
  },
  "973": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{$competitor2} 10/3 sixes head2head spread",
    "group": "all"
  },
  "974": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings - {$competitor1} Üst/Alt sixes spread",
    "group": "all"
  },
  "975": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings - {$competitor2} Üst/Alt sixes spread",
    "group": "all"
  },
  "976": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "Üst/Alt fours spread",
    "group": "all"
  },
  "977": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "Multi fours spread",
    "group": "all"
  },
  "978": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings - {$competitor1} Üst/Alt fours spread",
    "group": "all"
  },
  "979": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings - {$competitor2} Üst/Alt fours spread",
    "group": "all"
  },
  "980": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{$competitor1} joy of six spread",
    "group": "all"
  },
  "981": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{$competitor2} joy of six spread",
    "group": "all"
  },
  "982": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "Üst/Alt {upsnr} ups spread",
    "group": "all"
  },
  "984": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings - {$competitor1} Üst/Alt {upsnr} ups spread",
    "group": "all"
  },
  "985": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings - {$competitor2} Üst/Alt {upsnr} ups spread",
    "group": "all"
  },
  "988": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings overs 0 to {overnr} - {$competitor1} supremacy spread",
    "group": "all"
  },
  "989": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings overs 0 to {overnr} - {$competitor2} supremacy spread",
    "group": "all"
  },
  "992": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "Üst/Alt wides spread",
    "group": "all"
  },
  "993": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "Multi wides spread",
    "group": "all"
  },
  "994": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings {!overnr} over - Üst/Alt runs spread",
    "group": "all"
  },
  "995": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "Multi flyer spread",
    "group": "all"
  },
  "996": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "Üst/Alt run outs spread",
    "group": "all"
  },
  "997": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "Launch spread",
    "group": "all"
  },
  "998": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "Man of the match player performance spread",
    "group": "all"
  },
  "999": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{%player} Üst/Alt player performance spread",
    "group": "all"
  },
  "1000": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings overs {overnrX} x {overnrY} - {$competitor1} multi run spread",
    "group": "all"
  },
  "1001": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings overs {overnrX} x {overnrY} - {$competitor2} multi run spread",
    "group": "all"
  },
  "1002": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings - {%player} {upsnr} ups spread",
    "group": "all"
  },
  "1006": {
    "1966": "{%competitor1}",
    "1967": "draw",
    "1968": "{%competitor2}",
    "name": "2 ball (1x2)",
    "group": "all"
  },
  "1007": {
    "1969": "{%competitor1} ({+hcp})",
    "1970": "{%competitor2} ({-hcp})",
    "name": "2 ball (handicap)",
    "group": "all"
  },
  "1008": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{%competitor} Üst/Alt strokes",
    "group": "all"
  },
  "1010": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{%competitor} Üst/Alt eagles",
    "group": "all"
  },
  "1011": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{%competitor} Üst/Alt birdies",
    "group": "all"
  },
  "1012": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{%competitor} Üst/Alt pars",
    "group": "all"
  },
  "1013": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{%competitor} Üst/Alt bogeys",
    "group": "all"
  },
  "1014": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{%competitor} Üst/Alt 2+ over par",
    "group": "all"
  },
  "1016": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Üst/Alt eagles",
    "group": "all"
  },
  "1017": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Üst/Alt birdies",
    "group": "all"
  },
  "1018": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Üst/Alt pars",
    "group": "all"
  },
  "1019": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Üst/Alt bogeys",
    "group": "all"
  },
  "1020": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Üst/Alt 2+ over par",
    "group": "all"
  },
  "1021": {
    "70": "tek",
    "72": "çift",
    "name": "{%competitor} odd/even strokes",
    "group": "all"
  },
  "1023": {
    "1966": "{%competitor1}",
    "1967": "draw",
    "1968": "{%competitor2}",
    "name": "Hole {holenr} - 2 ball (1x2)",
    "group": "all"
  },
  "1024": {
    "1969": "{%competitor1} ({+hcp})",
    "1970": "{%competitor2} ({-hcp})",
    "name": "Hole {holenr} - 2 ball (handicap)",
    "group": "all"
  },
  "1025": {
    "74": "evet",
    "76": "hayır",
    "name": "Hole {holenr} - any player under par",
    "group": "all"
  },
  "1026": {
    "74": "evet",
    "76": "hayır",
    "name": "Hole {holenr} - {%competitor} under par",
    "group": "all"
  },
  "1028": {
    "1966": "{%competitor1}",
    "1967": "draw",
    "1968": "{%competitor2}",
    "name": "Holes {from} to {to} - 2 ball (1x2)",
    "group": "all"
  },
  "1029": {
    "1969": "{%competitor1} ({+hcp})",
    "1970": "{%competitor2} ({-hcp})",
    "name": "Holes {from} to {to} - 2 ball (handicap)",
    "group": "all"
  },
  "1030": {
    "1966": "{%competitor1}",
    "1967": "draw",
    "1968": "{%competitor2}",
    "name": "Holes {from} to {to} - 2 ball (1x2) most birdies",
    "group": "all"
  },
  "1031": {
    "1966": "{%competitor1}",
    "1967": "draw",
    "1968": "{%competitor2}",
    "name": "Holes {from} to {to} - 2 ball (1x2) most pars",
    "group": "all"
  },
  "1032": {
    "1966": "{%competitor1}",
    "1967": "draw",
    "1968": "{%competitor2}",
    "name": "Holes {from} to {to} - 2 ball (1x2) most bogeys",
    "group": "all"
  },
  "1036": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "berabere ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "{!quarternr} quarter - handicap {hcp}",
    "group": "all"
  },
  "1037": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "Race to {goals} goals",
    "group": "all"
  },
  "1040": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Üst/Alt hits (incl. extra innings)",
    "group": "all|incl_ei"
  },
  "1041": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{$competitor1} Üst/Alt hits (incl. extra innings)",
    "group": "all|incl_ei"
  },
  "1042": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{$competitor2} Üst/Alt hits (incl. extra innings)",
    "group": "all|incl_ei"
  },
  "1043": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr} inning - Üst/Alt hits",
    "group": "all"
  },
  "1044": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr} inning - {$competitor1} Üst/Alt hits",
    "group": "all"
  },
  "1045": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr} inning - {$competitor2} Üst/Alt hits",
    "group": "all"
  },
  "1046": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Innings 1 to 5 - Üst/Alt hits",
    "group": "all"
  },
  "1047": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Innings 1 to 5 - {$competitor1} Üst/Alt hits",
    "group": "all"
  },
  "1048": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Innings 1 to 5 - {$competitor2} Üst/Alt hits",
    "group": "all"
  },
  "1049": {
    "1978": "strike",
    "1979": "ball",
    "1980": "hit",
    "1981": "other",
    "name": "Result of {!pitchnr} pitch",
    "group": "all|rapid_market|pitch"
  },
  "1050": {
    "74": "evet",
    "76": "hayır",
    "name": "Hit on {!pitchnr} pitch",
    "group": "all|rapid_market|pitch"
  },
  "1051": {
    "74": "evet",
    "76": "hayır",
    "name": "Home run on {!pitchnr} pitch",
    "group": "all|rapid_market|pitch"
  },
  "1052": {
    "1982": "single",
    "1983": "double",
    "1984": "triple",
    "1985": "home run",
    "1986": "no further hit",
    "name": "Result of {!hitnr} hit",
    "group": "all|rapid_market|hit"
  },
  "1053": {
    "1987": "on base",
    "1988": "out",
    "1989": "home run",
    "name": "Result of {%player} {!appearancenr} time at bat",
    "group": "all|player|rapid_market"
  },
  "1054": {
    "74": "evet",
    "76": "hayır",
    "name": "{%player} to strike out {!appearancenr} time at bat",
    "group": "all|player|rapid_market"
  },
  "1055": {
    "973": "{$competitor1} & {total} +ü",
    "974": "{$competitor2} & {total} +ü",
    "975": "{$competitor1} & {total} -ı",
    "976": "{$competitor2} & {total} -ı",
    "name": "Winner & Üst/Alt",
    "group": "all|regular_play|combo"
  },
  "1056": {
    "973": "{$competitor1} & {total} +ü",
    "974": "{$competitor2} & {total} +ü",
    "975": "{$competitor1} & {total} -ı",
    "976": "{$competitor2} & {total} -ı",
    "name": "{!setnr} set - winner & Üst/Alt",
    "group": "all|combo|set"
  },
  "1057": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "{!quarternr} çeyrek - {pointnr} sayıya ilk ulaşacak olan",
    "group": "all|score|quarter"
  },
  "1061": {
    "1990": "rush",
    "1991": "pass",
    "name": "{!drivenr} drive play {playnr} - {%competitor} play type",
    "group": "all|drive"
  },
  "1062": {
    "74": "evet",
    "76": "hayır",
    "name": "{!drivenr} drive play {playnr} - {%competitor} pass completion",
    "group": "all|drive"
  },
  "1063": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!drivenr} drive play {playnr} - {%competitor} Üst/Alt yards gained",
    "group": "all|drive"
  },
  "1064": {
    "74": "evet",
    "76": "hayır",
    "name": "{!drivenr} drive play {playnr} - {%competitor} new first down",
    "group": "all|drive"
  },
  "1065": {
    "74": "evet",
    "76": "hayır",
    "name": "{!drivenr} drive play {playnr} - {%competitor} sack",
    "group": "all|drive"
  },
  "1066": {
    "1992": "punt",
    "1993": "touchdown",
    "1994": "field goal attempt",
    "1995": "other",
    "name": "{!drivenr} drive - {%competitor} result",
    "group": "all|drive"
  },
  "1067": {
    "973": "{$competitor1} & {total} +ü",
    "974": "{$competitor2} & {total} +ü",
    "975": "{$competitor1} & {total} -ı",
    "976": "{$competitor2} & {total} -ı",
    "name": "Winner & Üst/Alt (incl. extra innings)",
    "group": "all|incl_ei"
  },
  "1068": {
    "74": "evet",
    "76": "hayır",
    "name": "Will there be a grand slam (incl. extra innings)",
    "group": "all|incl_ei"
  },
  "1069": {
    "74": "evet",
    "76": "hayır",
    "name": "Any team win to nil (incl. extra innings)",
    "group": "all|incl_ei"
  },
  "1070": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!inningnr} inning - most strikes",
    "group": "all"
  },
  "1071": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!inningnr} inning - most balls",
    "group": "all"
  },
  "1072": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!inningnr} inning - most hits",
    "group": "all"
  },
  "1073": {
    "1996": "0",
    "1997": "1",
    "1998": "2+",
    "name": "{!inningnr} inning - exact home runs",
    "group": "all"
  },
  "1074": {
    "1996": "0",
    "1997": "1",
    "1998": "2+",
    "name": "{!inningnr} inning - {$competitor1} exact home runs",
    "group": "all"
  },
  "1075": {
    "1996": "0",
    "1997": "1",
    "1998": "2+",
    "name": "{!inningnr} inning - {$competitor2} exact home runs",
    "group": "all"
  },
  "1076": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr} inning - Üst/Alt pitches",
    "group": "all"
  },
  "1077": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr} inning - {$competitor1} Üst/Alt pitches",
    "group": "all"
  },
  "1078": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr} inning - {$competitor2} Üst/Alt pitches",
    "group": "all"
  },
  "1079": {
    "1999": "0",
    "2000": "1",
    "2001": "2",
    "2002": "3",
    "name": "{!inningnr} inning - {$competitor1} exact strikeouts",
    "group": "all"
  },
  "1080": {
    "1999": "0",
    "2000": "1",
    "2001": "2",
    "2002": "3",
    "name": "{!inningnr} inning - {$competitor2} exact strikeouts",
    "group": "all"
  },
  "1081": {
    "74": "evet",
    "76": "hayır",
    "name": "{!inningnr} inning - {$competitor1} to record a double or triple play",
    "group": "all"
  },
  "1082": {
    "74": "evet",
    "76": "hayır",
    "name": "{!inningnr} inning - {$competitor2} to record a double or triple play",
    "group": "all"
  },
  "1083": {
    "2005": "1-3",
    "2006": "4-5",
    "2007": "6+",
    "name": "Pitch range of {%player} {!appearancenr} time at bat",
    "group": "all"
  },
  "1084": {
    "1999": "0",
    "2000": "1",
    "2001": "2",
    "2002": "3",
    "name": "Exact strikes of {%player} {!appearancenr} time at bat",
    "group": "all"
  },
  "1085": {
    "1005": "0",
    "1006": "1",
    "1007": "2",
    "1008": "3",
    "1009": "4",
    "name": "Exact balls of {%player} {!appearancenr} time at bat",
    "group": "all"
  },
  "1086": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Üst/Alt speed of {!pitchnr} pitch",
    "group": "all"
  },
  "1087": {
    "961": "0",
    "962": "1",
    "963": "2",
    "964": "3",
    "965": "4",
    "966": "5+",
    "name": "Exact home runs (incl. extra innings)",
    "group": "all|incl_ei"
  },
  "1088": {
    "2008": "{$competitor1} 1 sayı",
    "2009": "{$competitor1} 2 sayı",
    "2010": "{$competitor1} 3 sayı",
    "2011": "{$competitor2} 1 sayı",
    "2012": "{$competitor2} 2 sayı",
    "2013": "{$competitor2} 3 sayı",
    "name": "Sayı yapma şekli {!pointnr}. sayı (uzatmalar dahil)",
    "group": "all"
  },
  "1089": {
    "2014": "1 sayı",
    "2015": "2 sayı",
    "2016": "3 sayı",
    "name": "Herhangi bir takım sayı yapma şekli {!pointnr}. sayı (uzatmalar dahil)",
    "group": "all"
  },
  "1090": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!quarternr} çeyrek - {!pointnr} sayı",
    "group": "all"
  },
  "1096": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Üst/Alt laps at {!stopnr} pit stop",
    "group": "all"
  },
  "1097": {
    "2017": "1-2",
    "2018": "3-4",
    "2019": "5-6",
    "2020": "7-8",
    "2021": "9-10",
    "2022": "11+",
    "name": "Grid position range of the winner",
    "group": "all"
  },
  "1098": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{%competitor} Üst/Alt overtakings",
    "group": "all"
  },
  "1099": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Üst/Alt finishers",
    "group": "all"
  },
  "1100": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Üst/Alt overtakings",
    "group": "all"
  },
  "1106": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{%team} Üst/Alt overtakings",
    "group": "all"
  },
  "1108": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!lapnr} lap - Üst/Alt retirements",
    "group": "all"
  },
  "1119": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Race to {pointnr} points",
    "group": "all"
  },
  "1120": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Üst/Alt home runs (incl. extra innings)",
    "group": "all|incl_ei|home_run"
  },
  "1121": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{$competitor1} Üst/Alt home runs (incl. extra innings)",
    "group": "all|incl_ei|home_run"
  },
  "1122": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{$competitor2} Üst/Alt home runs (incl. extra innings)",
    "group": "all|incl_ei|home_run"
  },
  "1123": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!inningnr} inning - Winner",
    "group": "all|inning"
  },
  "1124": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Innings 1 to 5 - Winner",
    "group": "all|5_innings"
  },
  "1125": {
    "74": "evet",
    "76": "hayır",
    "name": "{!inningnr} innings - {%player1} to score {milestone} & {%player2} {total} + dismissals",
    "group": "all"
  },
  "1127": {
    "74": "evet",
    "76": "hayır",
    "name": "{!inningnr} innings - {%player1} to score {milestone1} & {%player2} to score {milestone2}",
    "group": "all"
  },
  "1128": {
    "74": "evet",
    "76": "hayır",
    "name": "{!inningnr} innings - {%player1} & {%player2} to score {milestone} & {%player3} {total} + dismissals",
    "group": "all"
  },
  "1129": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr} innings - {%player1} + {%player2} Üst/Alt",
    "group": "all"
  },
  "1130": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr} innings - {%player1} + {%player2} + {%player3} Üst/Alt",
    "group": "all"
  },
  "1131": {
    "74": "evet",
    "76": "hayır",
    "name": "Both teams to score {milestone}",
    "group": "all"
  },
  "1132": {
    "74": "evet",
    "76": "hayır",
    "name": "{!inningsnr} innings  over {overnr} - deliveries {deliverynr1} & {deliverynr2} {$competitor1} {total} +",
    "group": "all"
  },
  "1133": {
    "74": "evet",
    "76": "hayır",
    "name": "{!inningsnr} innings  over {overnr} - deliveries {deliverynr1} & {deliverynr2} {$competitor2} {total} +",
    "group": "all"
  },
  "1134": {
    "1806": "fielder yakalama",
    "1807": "bowled",
    "1808": "kaleci yakalayışı",
    "1809": "lbw",
    "1810": "run out",
    "1811": "stumped",
    "1812": "diğer",
    "name": "{!inningnr} innings - {%player1} & {%player2} dismissal method",
    "group": "all"
  },
  "1135": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "Which team has the highest 1st partnership & 1st over & overs 0 to {overnr}",
    "group": "all"
  },
  "1136": {
    "2026": "0",
    "2027": "1",
    "2028": "2",
    "2029": "3",
    "2030": "4",
    "2031": "6",
    "2032": "other",
    "name": "{!inningnr} innings over {overnr} - {!deliverynr} delivery {$competitor1} exact runs",
    "group": "all"
  },
  "1137": {
    "2026": "0",
    "2027": "1",
    "2028": "2",
    "2029": "3",
    "2030": "4",
    "2031": "6",
    "2032": "other",
    "name": "{!inningnr} innings over {overnr} - {!deliverynr} delivery {$competitor2} exact runs",
    "group": "all"
  },
  "1138": {
    "74": "evet",
    "76": "hayır",
    "name": "{!inningnr} innings over {overnr} - {!deliverynr} delivery {$competitor1} to be a wicket",
    "group": "all"
  },
  "1139": {
    "74": "evet",
    "76": "hayır",
    "name": "{!inningnr} innings over {overnr} - {!deliverynr} delivery {$competitor2} to be a wicket",
    "group": "all"
  },
  "1140": {
    "1806": "fielder yakalama",
    "1807": "bowled",
    "1808": "kaleci yakalayışı",
    "1809": "lbw",
    "1810": "run out",
    "1811": "stumped",
    "1812": "diğer",
    "name": "{!inningnr} innings - {%player1} or {%player2} dismissal method",
    "group": "all"
  },
  "1141": {
    "74": "evet",
    "76": "hayır",
    "name": "{!inningnr} innings over {overnr} - {%player1} & {%player2} to hit a boundary",
    "group": "all"
  },
  "1142": {
    "74": "evet",
    "76": "hayır",
    "name": "{!inningnr} innings over {overnr} - {%player1} & {%player2} {total} +",
    "group": "all"
  },
  "1143": {
    "74": "evet",
    "76": "hayır",
    "name": "{!inningnr} innings over {overnr} - {$competitor1} to score a boundary four & a six",
    "group": "all"
  },
  "1144": {
    "74": "evet",
    "76": "hayır",
    "name": "{!inningnr} innings over {overnr} - {$competitor2} to score a boundary four & a six",
    "group": "all"
  },
  "1145": {
    "74": "evet",
    "76": "hayır",
    "name": "{!inningnr} innings - {%player1} or {%player2} to survive a review",
    "group": "all"
  },
  "1146": {
    "2023": "{%player1}",
    "2024": "none",
    "2025": "{%player2}",
    "name": "{!inningnr} innings - race to {runs} runs",
    "group": "all"
  },
  "1147": {
    "74": "evet",
    "76": "hayır",
    "name": "{%player} to score {milestone} & take a wicket & a catch",
    "group": "all"
  },
  "1148": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!overnr} over - {$competitor1} Üst/Alt ({ballcount}-ball overs)",
    "group": "all"
  },
  "1149": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!overnr} over - {$competitor2} Üst/Alt ({ballcount}-ball overs)",
    "group": "all"
  },
  "1150": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Overs 0 to {overnr} - {$competitor1} Üst/Alt ({ballcount}-ball overs)",
    "group": "all"
  },
  "1151": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Overs 0 to {overnr} - {$competitor2} Üst/Alt ({ballcount}-ball overs)",
    "group": "all"
  },
  "1152": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{%player} Üst/Alt rushing touchdowns (incl. overtime)",
    "group": "all"
  },
  "1158": {
    "2033": "{%competitor1}",
    "2034": "{%competitor2}",
    "name": "2 ball",
    "group": "all"
  },
  "1160": {
    "2033": "{%competitor1}",
    "2034": "{%competitor2}",
    "name": "Draw no bet",
    "group": "all"
  },
  "1161": {
    "1966": "{%competitor1}",
    "1967": "draw",
    "1968": "{%competitor2}",
    "name": "Head2head (1x2)",
    "group": "all"
  },
  "1162": {
    "1969": "{%competitor1} ({+hcp})",
    "1970": "{%competitor2} ({-hcp})",
    "name": "Hole handicap",
    "group": "all"
  },
  "1163": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{%competitor} Üst/Alt holes won",
    "group": "all"
  },
  "1165": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Üst/Alt holes played",
    "group": "all"
  },
  "1166": {
    "74": "evet",
    "76": "hayır",
    "name": "Will there be a tie",
    "group": "all"
  },
  "1168": {
    "1966": "{%competitor1}",
    "1967": "draw",
    "1968": "{%competitor2}",
    "name": "Hole {holenr} - head2head (1x2)",
    "group": "all"
  },
  "1169": {
    "2033": "{%competitor1}",
    "2034": "{%competitor2}",
    "name": "Hole {holenr} - draw no bet",
    "group": "all"
  },
  "1170": {
    "1966": "{%competitor1}",
    "1967": "draw",
    "1968": "{%competitor2}",
    "name": "Holes {from} to {to} - head2head (1x2)",
    "group": "all"
  },
  "1171": {
    "2033": "{%competitor1}",
    "2034": "{%competitor2}",
    "name": "Holes {from} to {to} - draw no bet",
    "group": "all"
  },
  "1173": {
    "973": "{$competitor1} & {total} +ü",
    "974": "{$competitor2} & {total} +ü",
    "975": "{$competitor1} & {total} -ı",
    "976": "{$competitor2} & {total} -ı",
    "name": "Winner (including OT) & Üst/Alt (including OT)",
    "group": "all"
  },
  "1174": {
    "2035": "{$competitor1} ({+hcp}) & {total} +",
    "2036": "{$competitor1} ({+hcp}) & {total} -",
    "2037": "{$competitor2} ({-hcp}) & {total} +",
    "2038": "{$competitor2} ({-hcp}) & {total} -",
    "name": "Handicap (including OT) & Üst/Alt (including OT)",
    "group": "all|combo|incl_ot"
  },
  "1175": {
    "794": "{$competitor1} & {total} -ı",
    "796": "{$competitor1} & {total} +ü",
    "798": "X & {total} -ı",
    "800": "X & {total} +ü",
    "802": "{$competitor2} & {total} -ı",
    "804": "{$competitor2} & {total} +ü",
    "name": "1st quarter 1x2 & 1st quarter Üst/Alt",
    "group": "all|combo|incl_ot"
  },
  "1176": {
    "2035": "{$competitor1} ({+hcp}) & {total} +",
    "2036": "{$competitor1} ({+hcp}) & {total} -",
    "2037": "{$competitor2} ({-hcp}) & {total} +",
    "2038": "{$competitor2} ({-hcp}) & {total} -",
    "name": "1st quarter handicap & 1st quarter Üst/Alt",
    "group": "all|combo|incl_ot"
  },
  "1177": {
    "794": "{$competitor1} & {total} -ı",
    "796": "{$competitor1} & {total} +ü",
    "798": "X & {total} -ı",
    "800": "X & {total} +ü",
    "802": "{$competitor2} & {total} -ı",
    "804": "{$competitor2} & {total} +ü",
    "name": "1st half 1x2 & 1st half Üst/Alt",
    "group": "all|combo|incl_ot"
  },
  "1178": {
    "2035": "{$competitor1} ({+hcp}) & {total} +",
    "2036": "{$competitor1} ({+hcp}) & {total} -",
    "2037": "{$competitor2} ({-hcp}) & {total} +",
    "2038": "{$competitor2} ({-hcp}) & {total} -",
    "name": "1st half handicap & 1st half Üst/Alt",
    "group": "all|combo|incl_ot"
  },
  "1179": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "1st Half Result or Match Result",
    "group": "all|regular_play"
  },
  "1183": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{%player} Üst/Alt shots (incl. overtime)",
    "group": "all|incl_ot"
  },
  "1185": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{%player} Üst/Alt shots on goal (incl. overtime)",
    "group": "all|incl_ot"
  },
  "1187": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{%player} Üst/Alt passes (incl. overtime)",
    "group": "all|incl_ot"
  },
  "1189": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{%player} Üst/Alt tackles (incl. overtime)",
    "group": "all|incl_ot"
  },
  "1193": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Highest scoring quarter - Üst/Alt",
    "group": "all|score|regular_play"
  },
  "1195": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Lowest scoring quarter - Üst/Alt",
    "group": "all|score|regular_play"
  },
  "1197": {
    "74": "evet",
    "76": "hayır",
    "name": "Any team to win both halves",
    "group": "all|score|regular_play"
  },
  "1199": {
    "74": "evet",
    "76": "hayır",
    "name": "Any team to win all quarters",
    "group": "all|score|regular_play"
  },
  "1201": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "Team to win both halves",
    "group": "all|score|regular_play"
  },
  "1203": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "Team to win all quarters",
    "group": "all|score|regular_play"
  },
  "1207": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "Next {!breaknr} break",
    "group": "all"
  },
  "1209": {
    "2039": "{$competitor1} 6-0, 6-1, 6-2",
    "2040": "{$competitor1} 6-3, 6-4",
    "2041": "{$competitor1} 7-5, 7-6",
    "2042": "{$competitor2} 6-0, 6-1, 6-2",
    "2043": "{$competitor2} 6-3, 6-4",
    "2044": "{$competitor2} 7-5, 7-6",
    "name": "{!setnr} set - exact score group",
    "group": "all"
  },
  "1211": {
    "74": "evet",
    "76": "hayır",
    "name": "Match to end {score}",
    "group": "all"
  },
  "1214": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr} innings - {%player} Üst/Alt deliveries faced",
    "group": "all"
  },
  "1215": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr} innings - {%player} runs conceded",
    "group": "all"
  },
  "1218": {
    "2045": "4",
    "2046": "6",
    "name": "{!inningnr} innings - {$competitor1} next boundary {boundary number} off Bat, Four or Six",
    "group": "all"
  },
  "1219": {
    "2045": "4",
    "2046": "6",
    "name": "{!inningnr} innings - {$competitor2} next boundary {boundary number} off Bat, Four or Six",
    "group": "all"
  },
  "1220": {
    "54": "0",
    "56": "1",
    "58": "2",
    "60": "3+",
    "name": "Üst/Alt batsman milestones (50s/100s)",
    "group": "all"
  },
  "1221": {
    "1037": "yakalar",
    "1038": "yakalayamaz",
    "name": "{!inningnr} innings - {$competitor1}  {!dismissalnr} dismissal method (limited)",
    "group": "all"
  },
  "1222": {
    "1037": "yakalar",
    "1038": "yakalayamaz",
    "name": "{!inningnr} innings - {$competitor2}  {!dismissalnr} dismissal method (limited)",
    "group": "all"
  },
  "1229": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr} innings overs 0 to {overnr} - {$competitor1} Üst/Alt",
    "group": "all"
  },
  "1230": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!inningnr} innings overs 0 to {overnr} - {$competitor2} Üst/Alt",
    "group": "all"
  },
  "1231": {
    "74": "evet",
    "76": "hayır",
    "name": "Sum of bonus balls exact number",
    "group": "all"
  },
  "1242": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Race to home {homepoints} and away {awaypoints} points",
    "group": "all"
  },
  "1243": {
    "74": "evet",
    "76": "hayır",
    "name": "Anytime exact score {homepoints}:{awaypoints}",
    "group": "all"
  },
  "1244": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "King of the Oche (Match Treble)",
    "group": "all"
  },
  "1246": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Player with highest checkout",
    "group": "all"
  },
  "1248": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Highest checkout in match",
    "group": "all"
  },
  "1250": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Üst/Alt {points}+ checkouts",
    "group": "all"
  },
  "1252": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "Match winner & highest checkout",
    "group": "all"
  },
  "1254": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "Match winner & most 180s",
    "group": "all"
  },
  "1256": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "Highest checkout & most 180s",
    "group": "all"
  },
  "1258": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "To lead after {!legnr} leg",
    "group": "all"
  },
  "1260": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!legnr} leg checkout Üst/Alt",
    "group": "all"
  },
  "1264": {
    "74": "evet",
    "76": "hayır",
    "name": "170 checkout in match",
    "group": "all"
  },
  "1269": {
    "74": "evet",
    "76": "hayır",
    "name": "{!setnr} set game {gamenr} - ace",
    "group": "all|micro_market"
  },
  "1270": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "{!setnr} set - {!acenr} ace",
    "group": "all|micro_market"
  },
  "1271": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!setnr} set - {$competitor1} Üst/Alt points",
    "group": "all|player_props"
  },
  "1272": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!setnr} set - {$competitor2} Üst/Alt points",
    "group": "all|player_props"
  },
  "1273": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!setnr} set - {$competitor2} Üst/Alt breaks",
    "group": "all|player_props"
  },
  "1274": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!setnr} set - {$competitor1} Üst/Alt aces",
    "group": "all|player_props"
  },
  "1275": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!setnr} set - {$competitor2} Üst/Alt aces",
    "group": "all|player_props"
  },
  "1276": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!setnr} set - most aces",
    "group": "all|player_props"
  },
  "1277": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!setnr} set - {$competitor1} Üst/Alt breaks",
    "group": "all|player_props"
  },
  "1278": {
    "74": "evet",
    "76": "hayır",
    "name": "Both players to win a set",
    "group": "all|score|regular_play"
  },
  "1279": {
    "2047": "4:0",
    "2048": "3:1",
    "2049": "2:2",
    "2050": "1:3",
    "2051": "0:4",
    "name": "{!setnr} set - doğru skor after 4 games",
    "group": "all|score|set"
  },
  "1280": {
    "2052": "6:0",
    "2053": "5:1",
    "2054": "4:2",
    "2055": "3:3",
    "2056": "2:4",
    "2057": "1:5",
    "2058": "0:6",
    "name": "{!setnr} set - doğru skor after 6 games",
    "group": "all|score|set"
  },
  "1281": {
    "6": "{$competitor1}",
    "7": "Gol olmaz",
    "8": "{$competitor2}",
    "name": "{!setnr} set - {!breaknr} break",
    "group": "all|score|set|micro_market"
  },
  "1282": {
    "74": "evet",
    "76": "hayır",
    "name": "{!setnr} set game {gamenr} - break point",
    "group": "all|score|game|micro_market"
  },
  "1283": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Booking handicap",
    "group": "all|regular_play|bookings"
  },
  "1284": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Overtime 1st half - Üst/Alt",
    "group": "all|score|ot_1st_half"
  },
  "1285": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{$competitor1} Üst/Alt points",
    "group": "all|score|regular_play|player_props"
  },
  "1286": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{$competitor2} Üst/Alt points",
    "group": "all|score|regular_play|player_props"
  },
  "1287": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{$competitor1} Üst/Alt breaks",
    "group": "all|score|regular_play|player_props"
  },
  "1288": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{$competitor2} Üst/Alt breaks",
    "group": "all|score|regular_play|player_props"
  },
  "1289": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{$competitor1} Üst/Alt aces",
    "group": "all|regular_play|player_props|ace"
  },
  "1290": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{$competitor2} Üst/Alt aces",
    "group": "all|regular_play|player_props|ace"
  },
  "1291": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Most aces",
    "group": "all|regular_play|player_props|ace"
  },
  "1292": {
    "2059": "point after rally",
    "2060": "ace",
    "2061": "double fault",
    "name": "{!setnr} set game {gamenr} - {!pointnr} point serve outcome",
    "group": "all|score|points|micro_market"
  },
  "1293": {
    "2064": "{$competitor1} winner",
    "2065": "{$competitor2} winner",
    "2066": "{$competitor1} error",
    "2067": "{$competitor2} error",
    "name": "{!setnr} set game {gamenr} - {!pointnr} point outcome",
    "group": "all|score|points|micro_market"
  },
  "1294": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{!setnr} set game {gamenr} - {!pointnr} point Üst/Alt shots",
    "group": "all|score|points|micro_market"
  },
  "1295": {
    "2068": "serve",
    "2069": "return",
    "2070": "forehand",
    "2071": "backhand",
    "2072": "volley",
    "name": "{!setnr} set game {gamenr} - {!pointnr} point last stroke",
    "group": "all|score|points|micro_market"
  },
  "1296": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Üst/Alt yellow cards",
    "group": "all|regular_play|bookings"
  },
  "1297": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "Üst/Alt red cards",
    "group": "all|regular_play|bookings"
  },
  "1298": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Yellow card 1x2",
    "group": "all|regular_play|bookings"
  },
  "1299": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Yellow card handicap",
    "group": "all|regular_play|bookings"
  },
  "1300": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{%player} Üst/Alt points (incl. overtime)",
    "group": "all"
  },
  "1301": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{%player} Üst/Alt assists (incl. overtime)",
    "group": "all"
  },
  "1302": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{%player} Üst/Alt rebounds (incl. overtime)",
    "group": "all"
  },
  "1303": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{%player} Üst/Alt 3-point field goals (incl. overtime)",
    "group": "all"
  },
  "1304": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{%player} Üst/Alt points + rebounds + assists (incl. overtime)",
    "group": "all|combo|incl_ot|player_props"
  },
  "1305": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "1st half - {points} point score draw no bet",
    "group": "all|score|1st_half|micro_market"
  },
  "1306": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "2nd half - {points} point score draw no bet",
    "group": "all|score|2nd_half|micro_market"
  },
  "1307": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!quarternr} quarter - {points} point score draw no bet",
    "group": "all|score|quarter|micro_market"
  },
  "1308": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "2 minutes - {points} point score draw no bet from {from} to {to} remaining",
    "group": "all|score|micro_market|2_min"
  },
  "1309": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "4 minutes - {points} point score draw no bet from {from} to {to} remaining",
    "group": "all|score|micro_market|4_min"
  },
  "1310": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "2 minutes - draw no bet from {from} to {to} remaining",
    "group": "all|score|micro_market|2_min"
  },
  "1311": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "4 minutes - draw no bet from {from} to {to} remaining",
    "group": "all|score|micro_market|4_min"
  },
  "1312": {
    "2073": "score",
    "2074": "no score",
    "name": "{!possessionnr} possession outcome",
    "group": "all|score|regular_play|micro_market"
  },
  "1313": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor1} to win all quarters",
    "group": "all|score|regular_play"
  },
  "1314": {
    "74": "evet",
    "76": "hayır",
    "name": "{$competitor2} to win all quarters",
    "group": "all|score|regular_play"
  },
  "1315": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{$competitor1} Üst/Alt double faults",
    "group": "all|regular_play|player_props|double fault"
  },
  "1316": {
    "12": "{total} +ü",
    "13": "{total} -ı",
    "name": "{$competitor2} Üst/Alt double faults",
    "group": "all|regular_play|player_props|double fault"
  },
  "1500": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Rest of Üst/Alt match",
    "group": "all"
  },
  "1601": {
    "16001": "{$competitor1} & 2-3 goals",
    "16002": "{$competitor1} & 2-4 goals",
    "16003": "{$competitor1} & 2-5 goals",
    "16004": "{$competitor1} & 3-4 goals",
    "16005": "{$competitor1} & 3-5 goals",
    "16006": "{$competitor1} & 3-6 goals",
    "16007": "draw & 2-3 goals",
    "16008": "draw & 2-4 goals",
    "16009": "draw & 2-5 goals",
    "16010": "draw & 3-4 goals",
    "16011": "draw & 3-5 goals",
    "16012": "draw & 3-6 goals",
    "16013": "{$competitor2} & 2-3 goals",
    "16014": "{$competitor2} & 2-4 goals",
    "16015": "{$competitor2} & 2-5 goals",
    "16016": "{$competitor2} & 3-4 goals",
    "16017": "{$competitor2} & 3-5 goals",
    "16018": "{$competitor2} & 3-6 goals",
    "name": "1x2 & Multigoals",
    "group": "all"
  },
  "1602": {
    "16021": "{$competitor1} or draw & 2-3 goals",
    "16022": "{$competitor1} or draw & 2-4 goals",
    "16023": "{$competitor1} or draw & 2-5 goals",
    "16024": "{$competitor1} or draw & 3-4 goals",
    "16025": "{$competitor1} or draw & 3-5 goals",
    "16026": "{$competitor1} or draw & 3-6 goals",
    "16027": "{$competitor1} or {$competitor2} & 2-3 goals",
    "16028": "{$competitor1} or {$competitor2} & 2-4 goals",
    "16029": "{$competitor1} or {$competitor2} & 2-5 goals",
    "16030": "{$competitor1} or {$competitor2} & 3-4 goals",
    "16031": "{$competitor1} or {$competitor2} & 3-5 goals",
    "16032": "{$competitor1} or {$competitor2} & 3-6 goals",
    "16033": "draw or {$competitor2} & 2-3 goals",
    "16034": "draw or {$competitor2} & 2-4 goals",
    "16035": "draw or {$competitor2} & 2-5 goals",
    "16036": "draw or {$competitor2} & 3-4 goals",
    "16037": "draw or {$competitor2} & 3-5 goals",
    "16038": "draw or {$competitor2} & 3-6 goals",
    "name": "Double chance & Multigoals",
    "group": "all"
  },
  "1603": {
    "16040": "0:0/1:1",
    "16041": "0:1/0:2/1:2",
    "16042": "0:3/1:3/2:3",
    "16043": "1:0/2:0/2:1",
    "16044": "1:4/2:4/3:4",
    "16045": "2:2/3:3/4:4",
    "16046": "3:0/3:1/3:2",
    "16047": "4:1/4:2/4:3",
    "16048": "4:0/0:4/Other",
    "name": "Multiscore-3",
    "group": "all"
  },
  "1604": {
    "16050": "0:0/1:1/0:1/1:0",
    "16051": "0:2/1:2/0:3/1:3",
    "16052": "0:4/1:4/2:4/3:4",
    "16053": "2:0/2:1/3:0/3:1",
    "16054": "2:2/2:3/3:2/3:3",
    "16055": "4:0/4:1/4:2/4:3",
    "16056": "4:4/Other",
    "name": "Multiscore-4",
    "group": "all"
  },
  "1605": {
    "16057": "{$competitor1} or no",
    "16058": "{$competitor1} or yes",
    "16059": "{$competitor2} or no",
    "16060": "{$competitor2} or yes",
    "16061": "draw or no",
    "16062": "draw or yes",
    "name": "1x2 or both teams to score",
    "group": "all"
  },
  "1606": {
    "16063": "{$competitor1}/draw / {$competitor1}/draw",
    "16064": "{$competitor1}/draw / {$competitor1}/{$competitor2}",
    "16065": "{$competitor1}/draw / draw/{$competitor2}",
    "16066": "{$competitor1}/{$competitor2} / {$competitor1}/draw",
    "16067": "{$competitor1}/{$competitor2} / draw/{$competitor2}",
    "16068": "draw/{$competitor2} / {$competitor1}/draw",
    "16069": "{$competitor1}/{$competitor2} / {$competitor1}/{$competitor2}",
    "16070": "draw/{$competitor2} / {$competitor1}/{$competitor2}",
    "16071": "draw/{$competitor2} / draw/{$competitor2}",
    "name": "Double chance Halftime/Fulltime",
    "group": "all"
  },
  "1607": {
    "16072": "{$competitor1} or {total} over",
    "16073": "draw or {total} over",
    "16074": "{$competitor2} or {total} over",
    "16075": "{$competitor1} or {total} under",
    "16076": "draw or {total} under",
    "16077": "{$competitor2} or {total} under",
    "name": "1x2 or {total} +/Alt",
    "group": "all"
  },
  "1608": {
    "16078": "yes or {total} over",
    "16079": "yes or {total} under",
    "16080": "no or {total} over",
    "16081": "no or {total} under",
    "name": "Both team to score or {total} +/Alt",
    "group": "all"
  },
  "1609": {
    "16082": "{$competitor1} and yes and {total} over",
    "16083": "{$competitor1} and no and {total} over",
    "16084": "{$competitor1} and no and {total} under",
    "16085": "draw and yes and {total} over",
    "16086": "draw and yes and {total} under",
    "16087": "draw and no and {total} under",
    "16088": "{$competitor2} and yes and {total} over",
    "16089": "{$competitor2} and no and {total} over",
    "16090": "{$competitor2} and no and {total} under",
    "name": "1x2 and Both team to score and {total} +/Alt",
    "group": "all"
  },
  "1610": {
    "16091": "<1 and <1",
    "16092": ">=1 and >=1",
    "16093": "<1 and <2",
    "16094": ">=1 and >=2",
    "16095": "<1 and <3",
    "16096": ">=1 and >=3",
    "16097": "<2 and <1",
    "16098": ">=2 and >=1",
    "16099": "<2 and <2",
    "16100": ">=2 and >=2",
    "16101": "<2 and <3",
    "16102": ">=2 and >=3",
    "16103": "<3 and <1",
    "16104": ">=3 and >=1",
    "16105": ">=3 and >=2",
    "16106": ">=3 and >=3",
    "name": "Exact goals in HT/2HT",
    "group": "all"
  },
  "1612": {
    "1": "{$competitor1}",
    "2": "draw",
    "3": "{$competitor2}",
    "name": "1x2 in 5 minutes",
    "group": "all"
  },
  "1613": {
    "1": "{$competitor1}",
    "2": "draw",
    "3": "{$competitor2}",
    "name": "1x2 in 10 minutes",
    "group": "all"
  },
  "1614": {
    "1": "{$competitor1}",
    "2": "draw",
    "3": "{$competitor2}",
    "name": "1x2 in 15 minutes",
    "group": "all"
  },
  "1615": {
    "1": "{$competitor1}",
    "2": "draw",
    "3": "{$competitor2}",
    "name": "1x2 in 20 minutes",
    "group": "all"
  },
  "1616": {
    "1": "{$competitor1}",
    "2": "draw",
    "3": "{$competitor2}",
    "name": "1x2 in 30 minutes",
    "group": "all"
  },
  "1617": {
    "1": "{$competitor1}",
    "2": "draw",
    "3": "{$competitor2}",
    "name": "1x2 in 60 minutes",
    "group": "all"
  },
  "1618": {
    "74": "yes",
    "76": "no",
    "name": "Score in first 5 min",
    "group": "all"
  },
  "1619": {
    "74": "yes",
    "76": "no",
    "name": "Score in first 10 min",
    "group": "all"
  },
  "1620": {
    "74": "yes",
    "76": "no",
    "name": "Score in first 15 min",
    "group": "all"
  },
  "1621": {
    "74": "yes",
    "76": "no",
    "name": "Score in first 20 min",
    "group": "all"
  },
  "1622": {
    "74": "yes",
    "76": "no",
    "name": "Score in first 30 min",
    "group": "all"
  },
  "1623": {
    "74": "yes",
    "76": "no",
    "name": "Score in first 60 min",
    "group": "all"
  },
  "1624": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor1} 2 goals in a row",
    "group": "all"
  },
  "1625": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor1} 3 goals in a row",
    "group": "all"
  },
  "1626": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor2} 2 goals in a row",
    "group": "all"
  },
  "1627": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor2} 3 goals in a row",
    "group": "all"
  },
  "1628": {
    "74": "yes",
    "76": "no",
    "name": "Any 2 goals in a row",
    "group": "all"
  },
  "1629": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor1} 3 goals in a row",
    "group": "all"
  },
  "1630": {
    "74": "yes",
    "76": "no",
    "name": "Both team to score 2+",
    "group": "all"
  },
  "1631": {
    "1": "{$competitor1}",
    "2": "draw",
    "3": "{$competitor2}",
    "name": "Halftime or fulltime",
    "group": "all"
  },
  "1632": {
    "1724": "{$competitor1}/draw &{total} -",
    "1725": "{$competitor1}/{$competitor2} & {total} -",
    "1726": "draw/{$competitor2} & {total} -",
    "1727": "{$competitor1}/draw & {total} +",
    "1728": "{$competitor1}/{$competitor2} & {total} +",
    "1729": "draw/{$competitor2} & {total} +",
    "name": "1st half - Double chance and Üst/Alt Halftime or Fulltime",
    "group": "all"
  },
  "1633": {
    "16114": "{$competitor1}/draw & {$competitor1}",
    "16115": "{$competitor1}/draw & {$competitor2}",
    "16116": "{$competitor1}/draw & draw",
    "16117": "{$competitor1}/{$competitor2} & {$competitor1}",
    "16118": "{$competitor1}/{$competitor2} & {$competitor2}",
    "16119": "{$competitor1}/{$competitor2} & draw",
    "16120": "draw/{$competitor2} & {$competitor1}",
    "16121": "draw/{$competitor2} & {$competitor2}",
    "16122": "draw/{$competitor2} & draw",
    "name": "Double chance (1st half) & 1x2",
    "group": "all"
  },
  "1634": {
    "16114": "{$competitor1}/draw & {$competitor1}",
    "16115": "{$competitor1}/draw & {$competitor2}",
    "16116": "{$competitor1}/draw & draw",
    "16117": "{$competitor1}/{$competitor2} & {$competitor1}",
    "16118": "{$competitor1}/{$competitor2} & {$competitor2}",
    "16119": "{$competitor1}/{$competitor2} & draw",
    "16120": "draw/{$competitor2} & {$competitor1}",
    "16121": "draw/{$competitor2} & {$competitor2}",
    "16122": "draw/{$competitor2} & draw",
    "name": "1x2 (1st half) & Double chance",
    "group": "all"
  }
};

export const global_marketname = {
  "1": "Maç Sonucu",
  "7": "Sifir skor bahis",
  "8": "Gelecek Gol",
  "10": "Çifte Şans",
  "18": "Üst/Alt",
  "19": "Ev takimi Toplam",
  "20": "Deplasman Toplam",
  "186": "Kazanan",
  "219": "12 Fazla Mesai Dahil",
  "225": "Alt/Üst Uzatmalar Dahil",
  "251": "Kazanan",
  "258": "Alt/Üst Uzatmalar Dahil",
  "340": "Kazanan"
};
